<script type="text/javascript">
import datas from "./store/mainArea";
/**接口**/
const axios = require("axios");
axios.defaults.timeout = 120 * 10000;
const qs = require("qs");
//登录
function userLogin(username, password) {
  return new Promise((resolve) => {
    axios
      .post(
        APILogin,
        qs.stringify({
          action: "login",
          type: "b",
          username,
          password,
        })
      )
      .then((res) => {
        try {
          const formatRes = JSON.parse(res.data);
          resolve(formatRes.status === "ok" ? formatRes.msg : false);
        } catch (e) {
          console.log("登录出错", e);
          resolve(false);
        }
      });
  });
}

//获取导入表
function getTableData(gdata) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          userid: Cookies.get("userid-b"),
          action: "edit",
          pagename: "getemptabledef",
          strJson: JSON.stringify(gdata),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取财务导入表
function getfinanceemptabledef(gdata) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          userid: Cookies.get("userid-b"),
          action: "edit",
          pagename: "getfinanceemptabledef",
          strJson: JSON.stringify(gdata),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
function addImportFiled(odata) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          userid: Cookies.get("userid-b"),
          action: "save",
          pagename: "saveempcolumndef",
          strJson: JSON.stringify(odata),
        })
      )
      .then((res) => {
        try {
          resolve(res);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
function customerInfo(info) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "getempcustlist",
          strJson: JSON.stringify(info)
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取财务客户列表
function getfinanceempcustlist(info) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "getfinanceempcustlist",
          strJson: JSON.stringify(info),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 上传Excel
function uploadCert(t) {
  // console.log(t);
  return new Promise((resolve) => {
    //  console.log('APIEnt',resolve);
    axios
      .post(APIEntBin, t, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        // console.log('APIEnt2',res);
        resolve(res.status === 200 ? res.data : false);
      });
  });
}
// 上传大文件
function uploadMaxFile(t) {
  // console.log(t);
  return new Promise((resolve) => {
    //  console.log('APIEnt',resolve);
    axios
      .post(APIMax, t, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        // console.log('APIEnt2',res);
        resolve(res.status === 200 ? res.data : false);
      });
  });
}
// 上传录音
function uploadVoice(t) {
  return new Promise((resolve) => {
    axios
      .post(APIChat + "/Chat/sendchatmsg", t, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        resolve(res.status === 200 ? JSON.parse(res.data) : false);
      });
  });
}
// 返回Excel路径
function returnExcelSrc(Edata) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          userid: Cookies.get("userid-b"),
          pagename: "anlysisexcel",
          strJson: JSON.stringify(Edata),
        })
      )
      .then((res) => {
        try {
          res.status == 200 ? resolve(res.data) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 返回财务Excel路径
function financeAnlysisExcelInf(Edata) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          userid: Cookies.get("userid-b"),
          pagename: "financeAnlysisExcelInf",
          strJson: JSON.stringify(Edata),
        })
      )
      .then((res) => {
        try {
          res.status == 200 ? resolve(res.data) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取Excel路径信息
function getPathInfo(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "getimpdatalist",
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取花名册信息
function getImportInfo(qdata) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          // pagename: "getimpdata",
          pagename: "getcurrdata",
          strJson: JSON.stringify(qdata),
        })
      )
      .then((res) => {
        try {
          res.status == 200 ? resolve(res.data.msg) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取财务清单花名册信息
function getfinancecurrdata(qdata) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "getfinancecurrdata",
          strJson: JSON.stringify(qdata),
        })
      )
      .then((res) => {
        try {
          res.status == 200 ? resolve(res.data.msg) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取历史信息详情
function getHistoryInfo(qdata) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          // pagename: "getimpdata",
          pagename: "getimpdata",
          strJson: JSON.stringify(qdata),
        })
      )
      .then((res) => {
        try {
          res.status == 200 ? resolve(res.data.msg) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//修改雇员信息
function editEmployeeInfo(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          userid: Cookies.get("userid-b"),
          pagename: "modifycurrdata",
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//代办事项操作
function WaiterWorkerOption(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "WaiterWorkerOption",
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data))
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//修改勘误页面的雇员信息
function editEmployeeInfo2(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          userid: Cookies.get("userid-b"),
          pagename: "modifycurrimpdata",
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//修改财务勘误页面的雇员信息
function modifyfinancecurrimpdata(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          userid: Cookies.get("userid-b"),
          pagename: "modifyfinancecurrimpdata",
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//从OA同步
function syncFromOA() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          userid: Cookies.get("userid-b"),
          pagename: "saveoadata",
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//校验入库
function checkInv(tableid, excelpath) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "backupdatatodb",
          tableid: tableid,
          excelpath: excelpath,
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取出错信息deleteEmployee
function getErrorInfo(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getimperrdata",
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(res.data.msg) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取财务错误列表
function getfinanceimperrdata(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getfinanceimperrdata",
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(res.data.msg) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//删除雇员
function deleteEmployee(StrFileNo) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "del",
          pagename: "delempuser",
          userid: Cookies.get("userid-b"),
          fileno: StrFileNo,
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//撤销删除雇员
function restedelemp() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "restedelemp",
          userid: Cookies.get("userid-b"),
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//拉黑雇员
function blacklistEmp(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "blacklistemp",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取待办事项列表
function getremindlist(data,roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "WaiterWorker",
          roletype,
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          res.status == 200 ? resolve(JSON.parse(res.data)) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取待办事项列表数量
function getremindcount() {
  // return new Promise((resolve) => {
  //   axios
  //     .post(
  //       APIEMP,
  //       qs.stringify({
  //         action: "edit",
  //         pagename: "getremindcount",
  //         userid: Cookies.get("userid-b"),
  //         content: "all",
  //       })
  //     )
  //     .then((res) => {
  //       try {
  //         resolve(res.data);
  //       } catch (e) {
  //         resolve(false);
  //       }
  //     });
  // });
}
//导出
function exportEmp(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "downcurrdata",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(res.data.msg) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取导入字段信息
function getImportFiledInfo(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "getempcolumninf",
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(res.data.msg) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取财务导入字段信息
function getfinanceempcolumninf(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "getfinanceempcolumninf",
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(res.data.msg) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取导入解析进程
function getImportProcess(path) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "getprocess",
          excelpath: path,
        })
      )
      .then((res) => {
        try {
          let jsonRus = JSON.parse(res.data);
          resolve(jsonRus);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//保存账号信息
function saveAccountInformation(infor) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEnt,
        qs.stringify({
          action: "save", //需要账户相关信息
          userid: Cookies.get("userid-b"),
          entid: Cookies.get("userid-b"),
          pagename: "accountinfo",
          accountInfo: JSON.stringify(infor),
        })
      )
      .then((res) => {
        console.log("dgd", res);
        try {
          const jsonRes = JSON.parse(res);
          jsonRes.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//匹配客户
function iterateCustomer(keyword) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          userid: Cookies.get("userid-b"),
          action: "edit",
          pagename: "getentlist",
          keyword,
        })
      )
      .then((res) => {
        try {
          const jsonRes = res;
          jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//上传图片
function uploadImage(mein) {
  return new Promise((resolve) => {
    //entpicinfo 企业风采
    //entproductinfo 产品图片
    //entteamnfo 成员
    let formData = new FormData();
    formData.append("action", "save");
    formData.append("userid", Cookies.get("userid-b"));
    formData.append("entid", mein.entid);
    formData.append("pagename", mein.type);
    mein.blobName
      ? formData.append("entPicFile", mein.entPicFile, mein.blobName)
      : formData.append("entPicFile", mein.entPicFile);
    formData.append("entPicTitle", mein.entPicTitle);
    formData.append("entPicDes", mein.entPicDes);
    formData.append("picid", mein.picid);
    axios
      .post(
        APIEntBin,
        qs.stringify({
          formData,
        })
      )
      .then((res) => {
        try {
          const jsonRes = JSON.parse(res);
          jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
    // $.ajax({
    //   url: APIEntBin,
    //   async: true,
    //   type: "post",
    //   cache: false,
    //   processData: false,
    //   contentType: false,
    //   dataType: "json",
    //   data: formData,
    //   success: res => {
    //     if (res) {
    //       try {
    //         const jsonRes = JSON.parse(res);
    //         jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
    //       } catch (e) {
    //         console.log("上传图片出错");
    //         resolve(false);
    //       }
    //     } else {
    //       console.log("上传图片出错");
    //     }
    //   },
    //   error:function(err){
    //     console.log('服务器出错',err)
    //     //store.state.login=false;
    //      alert('服务器出错，请稍后再试。')
    //   }
    // });
  });
}
//获取企业图片
function getCompanyImages(entid) {
  return new Promise((resolve) => {
    let formData = new FormData();
    formData.append("action", "edit");
    formData.append("userid", Cookies.get("userid-b"));
    formData.append("entid", entid);
    formData.append("pagename", "entpic");
    axios
      .post(
        APIEntBin,
        qs.stringify({
          formData,
        })
      )
      .then((res) => {
        try {
          const jsonRes = JSON.parse(res);
          jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
    // $.ajax({
    //   url: APIEntBin,
    //   async: true,
    //   type: "post",
    //   cache: false,
    //   processData: false,
    //   contentType: false,
    //   dataType: "json",
    //   data: formData,
    //   success: res => {
    //     if (res) {
    //       try {
    //         const jsonRes = JSON.parse(res);
    //         jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
    //       } catch (e) {
    //         console.log("获取企业图片出错");
    //         resolve(false);
    //       }
    //     } else {
    //       console.log("获取企业图片出错");
    //     }
    //   },
    //   error:function(err){
    //     console.log('服务器出错',err)
    //     //store.state.login=false;
    //      alert('服务器出错，请稍后再试。')
    //   }
    // });
  });
}
//上传头像
function uploadAvatar(entid, mein) {
  return new Promise((resolve) => {
    let formData = new FormData();
    formData.append("action", "save");
    formData.append("userid", Cookies.get("userid-b"));
    formData.append("entid", entid);
    mein.blobName
      ? formData.append("entPicFile", mein.entPicFile, mein.blobName)
      : formData.append("entPicFile", mein.entPicFile);
    formData.append("pagename", "entlogoinfo");
    axios
      .post(
        APIEntBin,
        qs.stringify({
          formData,
        })
      )
      .then((res) => {
        try {
          const jsonRes = JSON.parse(res);
          jsonRes.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
    // $.ajax({
    //   url: APIEntBin,
    //   async: true,
    //   type: "post",
    //   cache: false,
    //   processData: false,
    //   contentType: false,
    //   dataType: "json",
    //   data: formData,
    //   success: res => {
    //     if (res) {
    //       try {
    //         const jsonRes = JSON.parse(res);
    //         jsonRes.status == "ok" ? resolve(true) : resolve(false);
    //       } catch (e) {
    //         console.log("上传头像出错");
    //         resolve(false);
    //       }
    //     } else {
    //       console.log("上传头像出错");
    //     }
    //   },
    //    error:function(err){
    //     console.log('服务器出错',err)
    //     //store.state.login=false;
    //      alert('服务器出错，请稍后再试。')
    //   }
    // });
  });
}
//删除图片
function deletePic(entid, type, picid) {
  return new Promise((resolve) => {
    let formData = new FormData();
    formData.append("action", "del");
    formData.append("userid", Cookies.get("userid-b"));
    formData.append("entid", entid);
    formData.append("pagename", type);
    formData.append("picid", picid);
    axios
      .post(
        APIEntBin,
        qs.stringify({
          formData,
        })
      )
      .then((res) => {
        try {
          const jsonRes = JSON.parse(res);
          jsonRes.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取职能大类
function roleDivision() {
  return new Promise((resolve) => {
    axios
      .get(APIPsn + "/Psninfo/GetInf", {
        params: {
          pagename: "getmainjobfunc",
        },
      })
      .then((res) => {
        try {
          const jsonRes = JSON.parse(res);
          jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取职能小类
function roleOffspring(id) {
  return new Promise((resolve) => {
    axios
      .get(APIPsn + "/Psninfo/GetInf", {
        params: {
          pagename: "getjobfunc",
          FuncCode: id,
        },
      })
      .then((res) => {
        try {
          const jsonRes = JSON.parse(res);
          if (jsonRes.status == "ok") {
            let list = jsonRes.msg;
            let sorts = [];
            list.forEach((l) => {
              if (sorts.length == 0) {
                sorts.push({
                  sortname: l.funcindex,
                  children: [l.funcname],
                });
              } else {
                let site = "";
                let isExist = sorts.find((s, i) => {
                  if (s.sortname == l.funcindex) {
                    site = i;
                    return s;
                  }
                });
                if (!isExist) {
                  sorts.push({
                    sortname: l.funcindex,
                    children: [l.funcname],
                  });
                } else {
                  sorts[site].children.push(l.funcname);
                }
              }
            });
            resolve(sorts);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//根据code 获取地区信息
function codeToInfor(code) {
  return new Promise((resolve) => {
    axios
      .get(APIPsn + "/Psninfo/GetInf", {
        params: {
          pagename: "getarea",
          NationCode: code,
        },
      })
      .then((res) => {
        try {
          let data = JSON.parse(res);
          if (data.status == "ok") {
            resolve(data.msg);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取任务列表
function getTaskList(data) {
  return new Promise((resolve) => {
    axios.get(PyFetch + "/get_Tasklist/" + JSON.stringify(data)).then((res) => {
      try {
        const jsonRes = JSON.parse(res.data);
        res.status == "200" ? resolve(jsonRes) : resolve(false);
      } catch (e) {
        resolve(false);
      }
    });
  });
}
//添加任务
function addTask(data) {
  return new Promise((resolve) => {
    axios.get(PyFetch + "/add_Task/" + JSON.stringify(data)).then((res) => {
      try {
        const jsonRes = JSON.parse(res.data);
        res.status == "200" ? resolve(jsonRes) : resolve(false);
      } catch (e) {
        resolve(false);
      }
    });
  });
}
//获取采集配置
function getCollectionConfig(data) {
  return new Promise((resolve) => {
    axios
      .get(PyFetch + "/get_CollectionConfig/" + JSON.stringify(data))
      .then((res) => {
        try {
          const jsonRes = JSON.parse(res.data);
          res.status == "200" ? resolve(jsonRes) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//添加采集配置
function addCollectionConfig(data) {
  return new Promise((resolve) => {
    axios
      .get(PyFetch + "/add_CollectionConfig/" + JSON.stringify(data))
      .then((res) => {
        try {
          const jsonRes = JSON.parse(res.data);
          res.status == "200" ? resolve(jsonRes) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取企业库列表
function getEntLists(data) {
  return new Promise((resolve) => {
    axios.get(PyFetch + "/get_entlist/" + JSON.stringify(data)).then((res) => {
      try {
        const jsonRes = JSON.parse(res.data);
        res.status == "200" ? resolve(jsonRes) : resolve(false);
      } catch (e) {
        resolve(false);
      }
    });
  });
}
//获取服务城市
function getServeCity() {
  //getservercity
  return new Promise((resolve) => {
    axios
      .get(APIPsn + "/Psninfo/GetInf", {
        params: {
          pagename: "getarea",
          NationCode: code,
        },
      })
      .then((res) => {
        try {
          let data = JSON.parse(res);
          if (data.status == "ok") {
            resolve(data.msg);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取所有省份
function provinces() {
  return new Promise((resolve) => {
    axios
      .get(APIPsn + "/Psninfo/GetInf", {
        params: {
          pagename: "getallprovince",
        },
      })
      .then((res) => {
        try {
          if (res) {
            const raw = `{"msg": ${res}}`;
            let data = JSON.parse(raw);
            resolve(data.msg);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取省份下的所有城市
function citys(code) {
  return new Promise((resolve) => {
    axios
      .get(APIPsn + "/Psninfo/GetInf", {
        params: {
          pagename: "getallcity",
          NationCode: code,
        },
      })
      .then((res) => {
        try {
          if (res) {
            const raw = `{"msg": ${res}}`;
            let data = JSON.parse(raw);
            resolve(data.msg);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取城市下的所有区县
function areas(code) {
  return new Promise((resolve) => {
    axios
      .get(APIPsn + "/Psninfo/GetInf", {
        params: {
          pagename: "getallarea",
          NationCode: code,
        },
      })
      .then((res) => {
        try {
          if (res) {
            const raw = `{"msg": ${res}}`;
            let data = JSON.parse(raw);
            resolve(data.msg);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 权限-获取所有角色
function bGetPowerList() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "bGetPowerList",
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//获取登录成员权限getMemberRole
function getLoginPowerInf(userid, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b") ? Cookies.get("userid-b") : userid,
          pagename: "getLoginPowerInf",
          roletype,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//获取角色所有权限详情1 勾选 0 未勾选getRoleDtl
function getRoleInfo(roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          roletype: roletype,
          pagename: "bGetDefInf",
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//修改角色权限updateRole
function bSaveRoletypeInfo(roletype, powerlist) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          roletype: roletype,
          pagename: "bSaveRoletypeInfo",
          powerlist: powerlist,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取服务中心树形图(成员账号管理列表)
function getInststr(roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getInststr",
          instcode: "0000000000",
          userid: Cookies.get("userid-b"),
          roletype: roletype,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//获取服务中心列表
function getBaseInstList(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getBaseInstList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//根据服务中心角色查询用户
function getUserInfoByInstrole(instcode, roletype, data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getUserInfoByInstrole",
          userid: Cookies.get("userid-b"),
          instcode: instcode,
          roletype: roletype,
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//成员用户详情
function getUserDetail(userid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getUserDetail",
          userid: userid,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//查看客户
function GetcustomerInfoByuserid(userid, data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "GetcustomerInfoByuserid",
          userid: userid,
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//服务中心同步数据
function synchronizationInst() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "synchronizationInst",
          userid: Cookies.get("userid-b"),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//选择服务中心接口（用户新增修改）
function getUserTopInst() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getUserTopInst",
          userid: Cookies.get("userid-b"),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//添加修改用户
function saveLowUserInfo(userid, entid, query) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "saveLowUserInfo",
          userid: userid,
          entid: entid, //上级id
          accoutInfo: JSON.stringify(query),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//删除恢复成员
function delroleinfUser(userid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "del",
          pagename: "delroleinfUser",
          userid: userid,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//责任人列表  type 1 用户用  2 服务中心用
function getAllRoleEmpList(instcode, type) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getAllRoleEmpList",
          userid: Cookies.get("userid-b"),
          instcode: instcode,
          type: type,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 修改服务中心负责人
function updateInstInfoById(instcode, userid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "updateInstInfoById",
          userid: userid,
          instcode: instcode,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 手机号姓名判断 (成员新增用)
//查询用户是否重复，{userid：被检查人的userid,
///新用户为空/修改时的用户为用户id，
//usertype:b(b角色填b,个人填p,企业填e),
//chkval:手机（或者邮箱或者用户名，每次检查一个）}
function bCheckUserInfo(userid, usertype, chkval) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "bCheckUserInfo",
          userid: userid,
          usertype: usertype,
          chkval: chkval,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
function checkJbUserInfo(userid, usertype, chkval) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "checkJbUserInfo",
          userid: userid,
          usertype: usertype,
          chkval: chkval,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取导出历史
function getExpRec(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getoutfilelist",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取黑名单列表
function getBlackList(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getblacklist",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取最后一条导出记录
function getLastExpData(custname) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getlastimpdata",
          userid: Cookies.get("userid-b"),
          custname,
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//查询导出进度
function getExpProcess(custname) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getcurroutproc",
          userid: Cookies.get("userid-b"),
          custname,
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//(检索雇员信息管理)取登录用户所有的服务中心
function getsrarchinstlist() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getsrarchinstlistnew",
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//（管理员）所有的服务中心
function getsrarchinstAllList() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getsrarchinstlistnew",
          userid: "04F97C95-DF0F-4E4F-90DB-234E969EB323",
          roletype: localStorage.loginRoletype,
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//(检索)取登录用户所有项目立项部门
function getsrarchinstobjinstlist(strsrvcent, strobjname) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getsrarchinstobjinstlistnew",
          userid: Cookies.get("userid-b"),
          strsrvcent: strsrvcent,
          strobjname: strobjname,
          roletype: localStorage.loginRoletype,
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//(检索)取登录用户所有项目名称
function getsrarchinstobjlist(strsrvcent) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getsrarchinstobjlist",
          userid: Cookies.get("userid-b"),
          strsrvcent: strsrvcent,
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//修改雇员服务状态
function updateEmpCustListstrBusiStat(gdObjId, strBusiStat) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "updateEmpCustListstrBusiStat",
          gdObjId: gdObjId,
          strBusiStat: strBusiStat,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//修改雇员的负责客服（可以多条数据指定相同客服用逗号分割）
function updateEmpCustListgdUserId(gdObjIds, gdUserId, strUserName) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "updateEmpCustListgdUserId",
          gdObjIds: gdObjIds,
          gdUserId: gdUserId,
          strUserName: strUserName,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//取客服列表  OA管理用
function getallEmplowertListInfo() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getallEmplowertListInfo",
          userid: Cookies.get("userid-b"),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//备份
function backupdata(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "backupdata",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//查询导入格式出错的行列
function getBackList(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getbackmsg",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//查询导入格式出错的行列
function getErrColumn(excelpath) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getimplisterr",
          userid: Cookies.get("userid-b"),
          excelpath,
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//查询历史导出字段列表
function getHistoryFiled() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getimphistorycfg",
          userid: Cookies.get("userid-b"),
          tableid: "XZ_emp_UserBase",
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//获取导入模板下载路径
function getImportMode() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getinputmode",
          userid: Cookies.get("userid-b"),
          fileid: "Excel导入模板",
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//待办事项确认处理/撤销处理
function updatecustBystrfileNo(strjson, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "WaiterWorkerConfirm",
          strjson:JSON.stringify(strjson),
          userid: Cookies.get("userid-b"),
          roletype
        })
      )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//员工人数统计 day week  mouth
function getUserBasecensus(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getUserBasecensus",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//统计雇员员工详情页面
function getUserBasecensusdetail(strsrvcent, strdatetype, strdate, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getUserBasecensusdetail",
          strsrvcent: strsrvcent,
          strdatetype: strdatetype,
          strdate: strdate,
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//统计渠道 mouth  year
function getUserCity(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getUserCity",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//统计渠道详情
function getUserBaseCitydetail(strsrvcent, strdatetype, strdate, data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getUserBaseCitydetail",
          strsrvcent: strsrvcent,
          strdatetype: strdatetype,
          strdate: strdate,
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//统计渠道员工列表详情
function getBaseUserInCityList(strsrvcent, strdate, query) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getBaseUserInCityList",
          strsrvcent: strsrvcent,
          strdate: strdate,
          jsonstr: JSON.stringify(query),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//导出
function reportCurrDataTable(
  reporttype,
  strsrvcent,
  strdatetype,
  strdate,
  query
) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "reportCurrDataTable",
          reporttype: reporttype,
          strsrvcent: strsrvcent,
          strdatetype: strdatetype,
          strdate: strdate,
          jsonstr: JSON.stringify(query),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//同步导出是否成功的信息
function getlastimpdata(custname) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "getlastimpdata",
          custname: custname,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//强制入库
function putStorage(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "updatemodifydata",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务强制入库
function updatefinancemodifydata(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "updatefinancemodifydata",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//勘误导出
function errorCurrDataTable(custname, query) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "errorCurrDataTable",
          custname: custname,
          strJson: JSON.stringify(query),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务勘误导出
function errorfinanceDataTable(custname, tableid, query) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "errorfinanceDataTable",
          custname: custname,
          tableid: tableid,
          strJson: JSON.stringify(query),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//检查表头是否正确
function chkimpdatatbtype(query) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "chkimpdatatbtype",
          strJson: JSON.stringify(query),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//检查财务导入的表头是否正确
function chkfinanceimpdatatbtype(query) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "chkfinanceimpdatatbtype",
          strJson: JSON.stringify(query),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//删除财务客户花名册
function delfnncuserimport(query) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "del",
          userid: Cookies.get("userid-b"),
          pagename: "delfnncuserimport",
          strJson: JSON.stringify(query),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//删除雇员花名册
function delempuserimport(query) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "del",
          userid: Cookies.get("userid-b"),
          pagename: "delempuserimport",
          strJson: JSON.stringify(query),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//判断社保是否已经导入过
function isfinanceImpDataInsu(query) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "isfinanceImpDataInsu",
          strJson: JSON.stringify(query),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//撤销导入
function empUndoinputData(query) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "empUndoinputData",
          strobjname: query,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//上传导入模板
function importModel(url) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getexprotmode",
          userid: Cookies.get("userid-b"),
          fileid: "上传模板接口",
          url,
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//歷史花名冊詳情
function getBackUpUsers(query) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getBackUpUsers",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(query),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//提醒导出
function outputQueryEmpCust(query) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "WaiterWorkerExcel",
          userid: Cookies.get("userid-b"),
          roletype:localStorage.loginRoletype,
          strJson: JSON.stringify(query),
        })
      )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务管理接口
//获取财务导入历史
function getfinanceimpdatalist(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "getfinanceimpdatalist",
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data.msg);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//上传财务导入模板
function getfinanceexprotmode(fileid, url, tableid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getfinanceexprotmode",
          userid: Cookies.get("userid-b"),
          fileid,
          url,
          tableid,
        })
      )
      .then((res) => {
        try {
          res.data.status == "ok" ? resolve(true) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取下载财务导入模板下载路径
function getfinanceinputmode(fileid, tableid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getfinanceinputmode",
          userid: Cookies.get("userid-b"),
          fileid,
          tableid,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务总计
function getfinancetotalData(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getfinancetotalData",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务总计
function getfinancetotalDatacus(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getfinancetotalDatacus",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务总计导出
function reportfinanceCurrDataTable(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "reportfinanceCurrDataTable",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//修改关账日期
function closeaccount(cfgvalue) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "closeaccount",
          userid: Cookies.get("userid-b"),
          cfgvalue,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//关账日期查询
function getaccountDate(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getaccountDate",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务分析字段名
function getAnalysisColumnInf(tableid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getAnalysisColumnInf",
          userid: Cookies.get("userid-b"),
          tableid,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务分析列表
function getAnalysisTotalData(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getAnalysisTotalData",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          // const formatRes = JSON.parse(res.data);
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务分析表名
function getAnalysisTable() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getAnalysisTable",
          userid: Cookies.get("userid-b"),
          strJson: "",
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务分析更新统计
function getTaskAnalysisTotalData(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getTaskAnalysisTotalData",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务分析导出
function getOutAnalysisTotalData(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getOutAnalysisTotalData",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务分析总计
function getAllAnalysisTotalData(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getAllAnalysisTotalData",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务数据源列表
function getFinanceSourceData(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getfinanceSourcecurrdata",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务数据源列表筛选条件
function getScreenData(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getScreenData",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取员工详情
function getJbUserDetail(useridr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getJbUserDetail",
          userid: Cookies.get("userid-b"),
          useridr,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取组织架构树形图（tree）
function getorganstr1(strorgancode, roletype, data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getorganstr",
          userid: Cookies.get("userid-b"),
          strorgancode,
          roletype,
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data.msg);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//客户在线导出
function ReportExpFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Report/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//ArdCurStat 通用方法
function ArdCurStat(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/ArdCurStat/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//ArdCurStat 通用导出方法
function ArdCurStatExp(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/ArdCurStat/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

function CreateBuildOrder(id) {
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/ArdCurStat/CreateBuildOrder?Id=' + id,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
function getBaiduToken(url) {
  return new Promise(resolve => {
    axios({
      method: 'POST',
      url: 'APIbaidu' + url,
      dataType: 'json',
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
      .then((res) => {
        try {
          resolve(res);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
function baiduOCR(url,data) {
  return new Promise(resolve => {
    axios({
      method: 'POST',
      url: 'APIbaidu' + url,
      dataType: 'json',
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      },
      data
    })
      .then((res) => {
        try {
          resolve(res);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
function GetRefreshs(id) {
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/ArdCurStat/GetRefreshs?ProjectId=' + id,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取部门详情
function getOrganizationById(strorgancode) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getOrganizationById",
          userid: Cookies.get("userid-b"),
          strorgancode,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data.msg);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//新增/修改部门
function saveJbOrganization(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "saveJbOrganization",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(true);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//删除部门
function delOrganInfoById(strorgancode) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "delOrganInfoById",
          userid: Cookies.get("userid-b"),
          strorgancode,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//禁用/启用部门
function disableOrganInfoById(strorgancode, strIsDisable) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "disableOrganInfoById",
          userid: Cookies.get("userid-b"),
          strorgancode,
          strIsDisable,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//禁用/启用基础数据
function disableJbParameter(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "disableJbParameter",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//获取部门员工
function getUserInfoByorgancode1(strorgancode, roletype, data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getUserInfoByorgancode",
          userid: Cookies.get("userid-b"),
          strorgancode,
          roletype: roletype,
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//保存员工
function saveJbUserInfo(pagename, data, type) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: pagename,
          userid: Cookies.get("userid-b"),
          entid: Cookies.get("userid-b"),
          accoutInfo: JSON.stringify(data.userInfo),
          organInfo: JSON.stringify(data.inst),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//修改密码/重置密码
function editPsw(pagename, data, type) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: pagename,
          userid: Cookies.get("userid-b"),
          entid: Cookies.get("userid-b"),
          accoutInfo: JSON.stringify(data.userInfo),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//获取参数列表
function getTreestr(tableid, data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getTreestr",
          userid: Cookies.get("userid-b"),
          tableid,
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//获取法务主体
function getParameterList1(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getParameterList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//保存参数
function saveJbParameter(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "saveJbParameter",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//删除参数
function checkJborganname(chkval) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "checkJborganname ",
          userid: Cookies.get("userid-b"),
          chkval,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//删除参数
function delJbParameter(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "delJbParameter",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(true);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//导出部门员工/机构
function getOutUserLists(pagename, data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename,
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//取报表表头
function gettestreportHead(apiname, reportid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP + "/Empinfo/Report",
        qs.stringify({
          action: "read",
          pagename: "gettestreport",
          userid: Cookies.get("userid-b"),
          apiname,
          reportid,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//取报表
function gettestreport(apiname, reportid, data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP + "/Empinfo/Report",
        qs.stringify({
          action: "read",
          pagename: "gettestreport",
          userid: Cookies.get("userid-b"),
          apiname,
          reportid,
          strjson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//取报表
function gettestreportrefesh(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP + "/Empinfo/Report",
        qs.stringify({
          action: "read",
          pagename: "gettestreport",
          userid: Cookies.get("userid-b"),
          apiname: "refreshreportdate",
          strjson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//更新用户权限
function nonertndataquery(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP + "/Empinfo/Report",
        qs.stringify({
          action: "read",
          pagename: "gettestreport",
          userid: Cookies.get("userid-b"),
          apiname: "nonertndataquery",
          reportid: "UpdateUserReport",
          strjson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//财务数据源导出
function financeSourceData(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "financeSourceData",
          tableid: "XZ_emp_FnncDataSource",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务数据源导出
function updateEmpCustListWx(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "updateEmpCustListWx",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//财务月报、年报
function getFinanceSourceStatistics(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getFinanceSourceStatistics",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 获取客户列表
function getCustLists(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getCustLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取客户详情
function getCustDetail(custid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getCustDetail",
          userid: Cookies.get("userid-b"),
          custid: custid,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 保存客户
function saveJbCust(jsonstr, jsonstrma) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "saveJbCust",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          // 业务员
          jsonstrma: JSON.stringify(jsonstrma),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//  合同预览（发起签约）
function GetContractPreview(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "edit",
        pagename: "GetContractPreview",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 获取项目详情
function getProjectDetail(projectid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getProjectDetail",
          userid: Cookies.get("userid-b"),
          projectid: projectid,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取项目列表
function getProjectLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getProjectLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 保存项目
function BSaveJbProject(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "BSaveJbProject",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取参数列表
function getParameterList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getParameterList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取客户行业列表
function getSearchCustindust(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getSearchCustindust",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取部门员工列表
function getUserInfoByorgancode(strorgancode, roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getUserInfoByorgancode",
          userid: Cookies.get("userid-b"),
          strorgancode: strorgancode,
          roletype: roletype,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取客服列表
function getUserInfoBytoporgancode(strorgancode, roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getUserInfoBytoporgancode",
          userid: Cookies.get("userid-b"),
          strorgancode: strorgancode,
          roletype: roletype,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取下级人员
function getUserInfoBytopuser(strorgancode, roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getUserInfoBytopuser",
          userid: Cookies.get("userid-b"),
          strorgancode: strorgancode,
          roletype: roletype,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取服务中心设置/OA里的人员
function GetUserInfoBytopuser(strorgancode, roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "GetUserInfoBytopuser",
          userid: Cookies.get("userid-b"),
          strorgancode: strorgancode,
          roletype: roletype,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取组织架构树形图(部门)
function getorganstr(strorgancode, roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getorganstr",
          userid: Cookies.get("userid-b"),
          strorgancode: strorgancode,
          roletype: roletype,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取招聘管理简历分配部门和人员
function getOrganstrsreach(strorgancode, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getOrganstrsreach",
          userid: Cookies.get("userid-b"),
          strorgancode: strorgancode,
          roletype: "0383e791-72fd-4edc-aa70-2bcadminuser",
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 修改项目状态
function updateProStatue(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "updateProStatue",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取表头(花名册)
function getJbPageColumnDefList(strTableId) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getJbPageColumnDefList",
          userid: Cookies.get("userid-b"),
          strTableId: strTableId,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取花名册列表
function getEmpBaseUsersLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getEmpBaseUsersLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 导出花名册列表
function getOutEmpBaseUser(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getOutEmpBaseUser",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取简历列表
function getEmpResumeLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getEmpResumeLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 导出简历列表
function getOutResumeUser(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getOutResumeUser",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 更新简历信息
function getupdateEmpResumeUser(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getupdateEmpResumeUser",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 项目导出
function getOutProjectLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getOutProjectLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 客户导出
function getOutCustLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getOutCustLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 删除客户
function delbCust(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "delbCust",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 按钮权限
function getJbUserRolepageDetail(roletype, page) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getJbUserRolepageDetail",
          userid: Cookies.get("userid-b"),
          roletype: roletype,
          page: page,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 数据源校验详情
function getFinanceDataImpError(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getFinanceDataImpError",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 数据源校验导出
function getOutFnncDataSourceErr(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getOutFnncDataSourceErr",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 修改项目客服
function updateProService(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "updateProService",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 登录人员导入和删除花名册权限
function getSystemConfig() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getSystemConfig",
          userid: Cookies.get("userid-b"),
          jsonstr: "",
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取项目合同提醒列表
function getRemindProjectLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getRemindProjectLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 判断负责客服是否是登录人员的下级
function checkProStrservuserid(checkuserid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "checkProStrservuserid",
          userid: Cookies.get("userid-b"),
          checkuserid: checkuserid,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//标签组/标签 增删禁启
function setLabelManagement(data, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "setLabelManagement",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
          roletype,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//获取企微签名数据
function getsignatureinfo(data) {
  return new Promise((resolve) => {
    axios
      .post(
        LTAPP + "/QwInfo",
        // "http://10.0.0.253:8495/Ltapp/QwInfo",
        JSON.stringify(data)
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//获取企微launch_cod
function Getlaunch_code(data) {
  return new Promise((resolve) => {
    axios.post(LTAPP + "/QwInfo", JSON.stringify(data)).then((res) => {
      try {
        if (res.status == "200") {
          resolve(res.data);
        } else {
          resolve(false);
        }
      } catch (e) {
        resolve(false);
      }
    });
  });
}

//获取企微签名数据
function getqwcodeurl(data) {
  return new Promise((resolve) => {
    axios
      .post(
        LTAPP + "/QwInfo",
        // "http://10.0.0.253:8495/Ltapp/QwInfo",
        JSON.stringify(data)
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//手机号码换取登录信息
function getuseridbymobile(mobil) {
  return new Promise((resolve) => {
    axios
      .post(
        APILogin + "/Login/QwInfo",
        qs.stringify({
          action: "getuseridbymobile",
          mobil,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//取标签管理列表
function GetLabelManagement(roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "GetLabelManagement",
          userid: Cookies.get("userid-b"),
          roletype,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//取标签管理列表
function setlabelmanagementbatch(data, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "setlabelmanagementbatch",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
          roletype,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//获取招聘需求
function searchRecruitmentneed(data, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "searchRecruitmentneed",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
          roletype,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//无需商保
function updatePersonNoNeedInsure(data, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "updatePersonNoNeedInsure",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
          roletype,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//获取沟通列表
function getcomrecord(data, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getcomrecord",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
          roletype,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//停招
function updatarecruitplanstatus(data, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "updatarecruitplanstatus",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
          roletype,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//取地区三级数据
function getArea(Parent) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getarea",
          Parent,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//取地区三级数据(全部)
function getAreaAll() {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getareaall",
          Parent: "",
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//编辑岗位
function jobeditorsave(data, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "jobeditorsave",
          userid: Cookies.get("userid-b"),
          roletype,
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(JSON.parse(res.data));
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//取报表服务部门
function getrecrrservicesdepart(pagename, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename,
          userid: Cookies.get("userid-b"),
          roletype,
          jsonstr: "",
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(JSON.parse(res.data));
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//取报表设置列表
function getrpcyclelist() {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getrpcyclelist",
          userid: Cookies.get("userid-b"),
          strJson: "",
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//报表设置
function editrpcycle(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "editrpcycle",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//新建沟通
function addcomrecord(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "addcomrecord",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//财务报表导出
function financeSourcereport(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "financeSourcereport",
          userid: Cookies.get("userid-b"),
          tableid: "output_XZ_emp_FnncReport",
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//招聘需求计划二维码
function initLintSrcUserCode(strjson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "initLintSrcUserCode",
          userid: Cookies.get("userid-b"),
          strjson: JSON.stringify(strjson),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//招聘需求-查看招聘计划
function getRecruitPlanDetail(gdrecpId) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getRecruitPlanDetail",
          userid: Cookies.get("userid-b"),
          gdrecpId: gdrecpId,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//招聘需求-获取招聘排期
function getRecruitPlanTerm(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getRecruitPlanTerm",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr), //不传默认为新增时候用
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//招聘需求-分配需求
function saveJbBusiRecruitPlandepuser(jsonstr, jsonstrdepuser) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "saveJbBusiRecruitPlandepuser",
          userid: Cookies.get("userid-b"),
          strjson: JSON.stringify(jsonstr),
          jsonstrdepuser: JSON.stringify(jsonstrdepuser),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//招聘需求--获取自己权限内的项目
function getplancomrecordprojectlist(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getplancomrecordprojectlist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          roletype,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//招聘需求--获取自己权限内的客服
function getprojectstrservuseridList(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getprojectstrservuseridList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          roletype,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//招聘需求-保存招聘计划
function saveJbBusiRecruitPlan(
  strjson,
  jsonstrgap,
  jsonstrterm,
  jsonstrdepuser
) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "saveJbBusiRecruitPlan",
          userid: Cookies.get("userid-b"),
          strjson: JSON.stringify(strjson),
          jsonstrgap: JSON.stringify(jsonstrgap),
          jsonstrterm: JSON.stringify(jsonstrterm),
          jsonstrdepuser: JSON.stringify(jsonstrdepuser),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//招聘需求-保存招聘排期
function saveJbBusiRecruitPlanterm(strjson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "saveJbBusiRecruitPlanterm",
          userid: Cookies.get("userid-b"),
          strjson: JSON.stringify(strjson),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//查看岗位信息
function getjobdetails(Id) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getjobdetails",
          userid: Cookies.get("userid-b"),
          Id: Id,
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//删除岗位信息
function deljobdetails(Id, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "delrecruitmentplanjob",
          userid: Cookies.get("userid-b"),
          Id: Id,
          roletype: roletype,
        })
      )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//检查个人资源/公海资源导入表头格式是否正确
function chkPsnTableForm(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "chkPsnTableForm",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//检查全量 导入表头格式是否正确
function chkPsnTableFormql(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "chkPsnTableFormql",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
         resolve(JSON.parse(res.data.replace(/\n/g, '')));
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取项目自定义字段
function getJbbaseEmpColumnPro(Projectid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getJbbaseEmpColumnPro",
          userid: Cookies.get("userid-b"),
          Projectid
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取自离列表
function ByOutPerson(strJson,roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "ByOutPerson",
          roletype,
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//SEL通用方法
function SelFun(strJson,action,pagename) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action,
          pagename,
          roletype:localStorage.loginRoletype,
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//导出全量（项目）列表
function outputProjectList(strJson,pagename) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename,
          userid: Cookies.get("userid-b"),
          roletype:localStorage.loginRoletype,
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//导出PRO列表
function OutputByRpo(strJson,strtabid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename:'OutputByRpo',
          strtabid,
          userid: Cookies.get("userid-b"),
          roletype:localStorage.loginRoletype,
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//修改手机号
function updateEmpPhone(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "updateEmpPhone",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 返回Excel路径(个人资源/公海资源)
function psnAnlysisExcelInf(Edata) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          userid: Cookies.get("userid-b"),
          pagename: "psnAnlysisExcelInf",
          strJson: JSON.stringify(Edata),
        })
      )
      .then((res) => {
        try {
          console.log("psnAnlysisExcelInf", res);
          if (res.status == 200) {
            let results = JSON.parse(res.data);
            resolve(results);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取最后一条导出记录（个人资源/公海资源）
function getPsnDataOutStatus(custname) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getPsnDataOutStatus",
          userid: Cookies.get("userid-b"),
          custname,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取导出历史（个人资源/公海资源）
function getPsnDAtaOutList(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getPsnDAtaOutList",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取导入历史列表（个人资源/公海资源）
function getPsnImpDataList(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "getPsnImpDataList",
          strJson: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取当前状态列表 92
// 1 时间段 34 学历要求 39 工作经验要求 44 是否包住 48 性别 52 社保缴纳方式 57 是否包吃 60 是否包住
//64 是否加班 67 站班和坐班 70 班次 75 民族要求 80证书要求 83 薪资单位 86 薪资类型 89 劳动关系
function getdictdatalistbyid(Id) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getdictdatalistbyid",
          Id: Id,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
function GetDictDataTreeListById(Id) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "GetDictDataTreeListById",
          Id: Id,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取表头列表（通用）（个人资源/公海资源）
function getJbbasePageColumnList(strTableId, strIsFixed) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getJbbasePageColumnList",
          userid: Cookies.get("userid-b"),
          strTableId: strTableId,
          strIsFixed: strIsFixed,
        })
      )
      .then((res) => {
        try {
          // else if (res.status == 401) {
          //   Cookies.remove("userid-b");
          //   Cookies.remove("entid-b");
          //   Cookies.remove("token");
          //   this.$store.commit("setLogin", false);
          //   location.href = location.origin+'/login'
          // }
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取表头列表（报表）
function getReportColumnList(strTableId, data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getReportColumnList",
          userid: Cookies.get("userid-b"),
          strTableId: strTableId,
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取个人资源列表
function getprivateResumeLists(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getprivateResumeLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取常用的标签列表
function getCommonlabelLists(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getCommonlabelLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取公海资源列表
function getpublicResumeLists(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getpublicResumeLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取报名列表
function getsignResumeLists(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          //pagename: "getsignResumeLists",
          pagename: "getsignResumeListsNew",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取简历的标签
function GetresumelabelLists(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "GetresumelabelLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 保存打标签
function savelabelResume(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "savelabelResume",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 修改当前状态
function saveResumeWorkState(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "saveResumeWorkState",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//上传个人资源/公海资源导入模板
function getpsnExprotMode(url) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getpsnExprotMode",
          userid: Cookies.get("userid-b"),
          tableid: "output_JB_busi_PsnBaseImp",
          fileid: "简历导入表",
          url,
        })
      )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = JSON.parse(res.data);
            upmodeRes.status == "ok" ? resolve(true) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取导入模板下载路径
function getPsnOutPutMode() {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getPsnOutPutMode",
          userid: Cookies.get("userid-b"),
          tableid: "output_JB_busi_PsnBaseImp",
          fileid: "简历导入表",
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 简历录入修改
function saveResumeinfo(jsonstr, jsonstrkill, jsonstredu, jsonstrwork) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "saveResumeinfo",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          jsonstrkill: JSON.stringify(jsonstrkill),
          jsonstredu: JSON.stringify(jsonstredu),
          jsonstrwork: JSON.stringify(jsonstrwork),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 投入公海
function LaunchResumepublic(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "LaunchResumepublic",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 简历分配
function distResumeinfo(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "distResumeinfo",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 岗位列表
function gethotjobopeningslist(seachStr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "gethotjobopeningslist",
          userid: Cookies.get("userid-b"),
          seachStr: seachStr,
          roletype: roletype,
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 简历详情
function getResumeDetail(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getResumeDetail",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 录入简历手机号验证
function checkResumeMobile(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "checkResumeMobile",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 个人资源/公海资源设置
function saveSetUpgdUserid(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "saveSetUpgdUserid",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 导出简历
function outputResumeList(type, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          //pagename: "outputResumeList",
          pagename: "outputResumeListNew",
          userid: Cookies.get("userid-b"),
          type: type,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 导出报表
function outReportExcel(strTableId, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "outReportExcel",
          userid: Cookies.get("userid-b"),
          strTableId,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 导出报表
function saveRecruitdepuserbatch(jsonstr,jsonstrdepuser) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "saveRecruitdepuserbatch",
          userid: Cookies.get("userid-b"),
          jsonstrdepuser:JSON.stringify(jsonstrdepuser),
          strjson: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 扫码入职人员导出
function H5OutExcel(jsonstr,roleType) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "H5OutExcel",
          userid: Cookies.get("userid-b"),
          roleType,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 导出招聘需求
function outputJobList(type, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "outputJobList",
          userid: Cookies.get("userid-b"),
          type: type,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取基础数据
function getBasicDatas(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getBasicDatas",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 取跟进记录
function getresumePsnfowrecords(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getresumePsnfowrecords",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 取服务状态记录
function getresumePsnstatusrecords(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getstatusrecordsByresumeIdpro",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 根据简历id获取岗位列表
function gettencentwxrecruitmentplanjob(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "gettencentwxrecruitmentplanjob",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          roletype,
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 新增跟进记录
function savePsnfowrecords(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "savePsnfowrecords",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 新增服务状态记录
function savePsnStatusrecords(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "savePsnStatusrecords",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//图片压缩
async function imgCompress(file) {
  // 将文件转img对象
  const img = await fileToImg(file);
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    // 获取文件宽高比例
    const { width: originWidth, height: originHeight } = img;
    // 自定义等比例缩放宽高属性，这里我用的是固定800宽度，高度是等比例缩放
    const scale = +(originWidth / originHeight).toFixed(2); // 比例取小数点后两位)
    const targetWidth = 800; // 固定宽
    const targetHeight = Math.round(800 / scale); // 等比例缩放高

    canvas.width = targetWidth;
    canvas.height = targetHeight;
    context.clearRect(0, 0, targetWidth, targetHeight);
    // canvas重新绘制图片
    context.drawImage(img, 0, 0, targetWidth, targetHeight);
    // canvas转二进制对象转文件对象，返回
    const type = "image/png";
    canvas.toBlob(function (blob) {
      const f = new File([blob], file.name, {
        type,
        lastModified: file.lastModified,
      });
      resolve(f);
    }, type);
  });
}

// file转换成img对象
function fileToImg(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();
    reader.onload = function (e) {
      img.src = e.target.result;
    };
    reader.onerror = function (e) {
      reject(e);
    };
    reader.readAsDataURL(file);
    img.onload = function () {
      resolve(img);
    };
    img.onerror = function (e) {
      reject(e);
    };
  });
}

// 获取设置详情
function getSetUpgdUserid() {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getSetUpgdUserid",
          userid: Cookies.get("userid-b"),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取分配记录
function getdistrecords(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getdistrecords",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取分配简历详情记录
function getdistResumerecords(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getdistResumerecords",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 发送消息通知
function sendnotify(roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "sendnotify",
          userid: Cookies.get("userid-b"),
          roletype: roletype,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 消息模版列表
function gettemplatelist(roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "gettemplatelist",
          userid: Cookies.get("userid-b"),
          roletype: roletype,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 消息通知记录列表
function getnotifyrecord(roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getnotifyrecord",
          userid: Cookies.get("userid-b"),
          roletype: roletype,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 人岗匹配列表
function wxappgetjoblist(roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "wxappgetjoblist",
          userid: Cookies.get("userid-b"),
          roletype: roletype,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 项目相关信息
function GetProjectInfo(roletype, strjson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "GetProjectInfo",
          userid: Cookies.get("userid-b"),
          roletype: roletype,
          strjson: JSON.stringify(strjson),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 获取项目人员详情
function getprojectpersondetails(id, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getprojectpersondetails",
          userid: Cookies.get("userid-b"),
          roletype: roletype,
          id: id,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 登陆的用户换取企业微信
function getqwUserid(userid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getqwUserid",
          userid: Cookies.get("userid-b"),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 一键同步
function getfollowuserc(qwuserid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getfollowuserc",
          userid: Cookies.get("userid-b"),
          qwuserid: qwuserid,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 简历分配剩余条数
function getresumePsndistcount(qwuserid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getresumePsndistcount",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 删除简历中的教育经验等
function delresumepro(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "del",
          pagename: "delresumepro",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 流程表头 报名  已约面   到面  通过  在职  异常  离职  流程已入职  流程未入职（流程统计中）
function getProcessColumnList(ststus) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getJbbasePageColumnStatus",
          userid: Cookies.get("userid-b"),
          ststus: ststus,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 流程记录
function getsignResumeRecordLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getsignResumeRecordLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 通过身份证号校验
function checkDrzByidcard(jsonstr,pagename) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename,
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 批量入职
function AddEmponwork(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename:'AddEmponwork',
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 流程回退
function fallbackPsnStatus(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename:'fallbackPsnStatus',
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 添加流程记录
function saveProcessRecords(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "savePsnStatusrecords",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 添加转岗记录
function savetransferrecords(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "savetransferrecords",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 转岗
function transferEmpData(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "transferEmpData",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 流程数字显示
function getsignResumecount(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          //pagename: "getsignResumecount",
          pagename: "getsignResumecountNew",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 校验简历是否已被约面 是否已被报名
function getresumestatuscheck(StrState, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getresumestatuscheck",
          userid: Cookies.get("userid-b"),
          StrState: StrState,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 入职Emp接口
function inducEmpData(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "inducEmpData",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 入职时取数据
function broleInducEmpData(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "broleInducEmpData",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 入职登记时取数据
function broleInducRegister(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "broleInducRegister",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 离职Emp接口
function quitEmpData(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "quitEmpData",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 离职时取数据
function brolequitEmpData(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "brolequitEmpData",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取在职情况Emp接口
function getempdetail(strIdCard) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getbroleempdetail",
          userid: Cookies.get("userid-b"),
          strIdCard: strIdCard,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 身份证校验
function checkidcardEmp(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "checkidcardEmp",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 检查岗位名称是否重名
function jobeditorsavecheck(data, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "jobeditorsavecheck",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
          roletype,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 报名/约面
function saveSigninfo(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "saveSigninfo",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 资源库-项目/岗位列表
function getresourcechangejoblist(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getresourcechangejoblist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          roletype: roletype,
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 资源库-根据岗位获取面试时间列表
function getresourceavailabletime(id, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getresourceavailabletime",
          id: id,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 报名二维码生成
function getapplyjoobqrcodegenerated(roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getapplyjoobqrcodegenerated",
          userid: Cookies.get("userid-b"),
          roletype: roletype,
          strJson: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 获取自己可看到的岗位列表
function getresourcejobcategoryblist(roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getresourcejobcategoryblist",
          userid: Cookies.get("userid-b"),
          roletype: roletype,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取流程中的在职列表
function getsignResumeListsonwork(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          //pagename: "getsignResumeListsonwork",
          pagename: "getsignResumeListsonworkNew",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取导入的错误列表
function getErrtPsnImpDataList(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getErrtPsnImpDataList",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 强制入库
function RelmpEmp(strJson,roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "ReImpEmp",
          userid: Cookies.get("userid-b"),
          strjson: JSON.stringify(strJson),
          roletype
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 添加到岗时间
function updateDtreachtime(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "updateDtreachtime",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取招聘里分配详情
function getRecruitPlandeps(gdrecpId, strorgancodes) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getRecruitPlandeps",
          userid: Cookies.get("userid-b"),
          gdrecpId: gdrecpId,
          strorgancodes: strorgancodes,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取岗位约面日期
function getjobdateappoint(Id, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getjobdateappoint",
          Id: Id,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取岗位约面时间
function getjobappointtime(Id, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getjobappointtime",
          Id: Id,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取线索库
function getClueData(jsonstr) {
  // console.log('gg',PyFetch+'/get_joblist/'+JSON.stringify(jsonstr)+'')
  return new Promise((resolve) => {
    axios
      .get(PyFetch + "/get_joblist/" + JSON.stringify(jsonstr))
      .then((res) => {
        try {
          const jsonRes = JSON.parse(res.data);
          res.status == 200 ? resolve(jsonRes) : resolve(false);
        } catch (e) {
          console.log(e);
          resolve(false);
        }
      });
  });
}
//获取基础数据(爬虫)
function getPythonBasicData(jsonstr) {
  // console.log('gg',PyFetch+'/get_joblist/'+JSON.stringify(jsonstr)+'')
  return new Promise((resolve) => {
    axios
      .get(PyFetch + "/get_Basicdata/" + JSON.stringify(jsonstr))
      .then((res) => {
        try {
          const jsonRes = JSON.parse(res.data);
          res.status == "200" ? resolve(jsonRes) : resolve(false);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 走定时任务(异常状态)
function taskPsnStatuszz() {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "taskPsnStatuszz",
          userid: "caa39434-539c-40cb-95d6-31b215f0f9dc",
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取背调项目
function getcertmenu(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getcertmenu1",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 创建背调二维码
function CreateQrCode(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "save",
          pagename: "CreateQrCode",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取导入模板
function getImportquerytemplate(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getImportquerytemplate",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// cert通用方法
function certFun(data,pagename) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename,
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取二维码列表
function GetQrCode(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "GetQrCode",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取闪查二维码报名列表
function QueryRecord(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "QueryRecord",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 删除闪查二维码
function DeleteQrCode(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "save",
          pagename: "DeleteQrCode",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 停止使用闪查二维码
function StopQrCode(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "save",
          pagename: "StopQrCode",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//闪查二维码信息详情
function QueryCert(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICert + '/Cert/QueryCert',
      qs.stringify({
        jsonstr
      })
    )
      .then((res) => {
        try {
          resolve((res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 重新生成背调二维码
function ReCreateQrCode(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "save",
          pagename: "ReCreateQrCode",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//背调h5闪查报告
function QueryCertReport(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICert + '/Cert/QueryCertReport',
      qs.stringify({
        jsonstr
      })
    )
      .then((res) => {
        try {
          resolve((res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 获取申请试用
function getTrialSubmitList(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getTrialSubmitList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 开始背调
function startcert(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "startcert",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取背调内部项目列表
function getprojectlist(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getprojectlist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取背调内部项目 产品权限
function getcertproductbusi(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getcertproductbusi",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 保存客户的产品权限设置
function updatacertproductbusi(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "updatacertproductbusi",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取背调订单详情
function getcertorderdetail(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getcertorderdetail",
          userid: Cookies.get("userid-b"),
          jsonstr: data,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取背调订单列表
function getcertorderlist(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getcertorderlist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取背调产品菜单
function getMenuProduct(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getcertmenu",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 法院被执行人—高级版取表头
function getbairongExecutionPro(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getbairongExecutionPro",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 背调工作台
function getworkingdisplaystation(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getworkingdisplaystation",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 编辑/新增/删除背调产品菜单
function updatacertmenu(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "updatacertmenu",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 编辑/新增/删除背调产品菜单
function walletrechargeadjustment(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "walletrechargeadjustment",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 管理员取所有的外部客户列表
function getcustomer(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getcustomer",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 背调账号新建修改
function updatacustomeruser(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "updatacustomeruser",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 保存新增客户、项目
function createcustomer(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "createcustomer",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 编辑新增删除背调客户
function updatacustomer(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "updatacustomer",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 背调个客户下所有的账号
function getcustomeruser(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getcustomeruser",
          userid: Cookies.get("userid-b"),
          jsonstr: data,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 密码重置
function updatauserpwd(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "updatauserpwd",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 批量背调
function batchstartcert(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "batchstartcert",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取企业联系方式
function getentcontactnum(strEntName, strEntNice) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getentcontactnum",
          strEntName,
          strEntNice,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 其他渠道获取企业联系方式
function getentContactnumbyother(strEntName) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          userid: Cookies.get("userid-b"),
          pagename: "getentContactnumbyother",
          strEntName,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 添加企业联系人
function addEntcontactnum(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "addEntcontactnum",
          jsonstr: JSON.stringify(data),
          userid: Cookies.get("userid-b"),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取客户线索表头
function getEcrmColumnList(strTableId, strIsFixed) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getEcrmColumnList",
          userid: Cookies.get("userid-b"),
          strTableId: strTableId,
          strIsFixed: strIsFixed, //0有效 1无效
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取潜在客户线索/CRM客户线索
function getCusLeadsLists(jsonstr, pagename) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: pagename,
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 01取查看全部跟进，全部认领,数据权限
function getroleareaIsdataAdmin() {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: 'getroleareaIsdataAdmin',
          userid: Cookies.get("userid-b"),
          jsonstr: '',
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 修改地区
function updataEntfolloEntAdd(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: 'updataEntfolloEntAdd',
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 导出潜在客户线索/CRM客户线索
function outputEcrmList(strTableId, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "outputEcrmList",
          userid: Cookies.get("userid-b"),
          strTableId: strTableId,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//灵活用工
// 获取表头
function getEcustColumnList(strTableId, strIsFixed) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getEcrmColumnList",
          userid: Cookies.get("userid-b"),
          strTableId: strTableId,
          strIsFixed: strIsFixed,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取数据导入的模板
function getcrmOutPutMode(tableid, fileid) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getcrmOutPutMode",
          userid: Cookies.get("userid-b"),
          tableid: tableid,
          fileid: fileid,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取法务主体列表
function getlegalsubjectlist(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getlegalsubjectlist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取法务主体基本信息
function getlegalsubjectdetails(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getlegalsubjectdetails",
          userid: Cookies.get("userid-b"),
          jsonstr,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取法务主体财务信息
function getlegalfinancedetails(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getlegalfinancedetails",
          userid: Cookies.get("userid-b"),
          jsonstr,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//保存法务主体基本信息
function updatelegalsubject(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "updatelegalsubject",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//保存法务主体财务信息
function updatelegalfinance(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "updatelegalfinance",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//获取方案列表
function getbslist(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getbslist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

function updatebillingscheme(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "updatebillingscheme",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 获取社保列表
function getsslist(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getsslist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 删除社保
function delSocialSecurity(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "delSocialSecurity",
          userid: Cookies.get("userid-b"),
          jsonstr: (jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取商保列表
function getbIlist(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getbIlist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 保存社保信息
function updatess(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "updatess",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 保存商保信息
function updatebi(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "updatebi",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 获取案例列表
function getcustomecaselist(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getcustomecaselist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 保存案例信息
function updatecustomecase(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "updatecustomecase",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 获取合同模板列表
function getcontracttemplist(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getcontracttemplist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 保存合同模板信息
function updatecontracttemp(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "updatecontracttemp",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 获取招投标网站列表
function getBiddingwebsiteList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getBiddingwebsiteList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 保存招投标网站信息
function updateBiddingwebsite(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "updateBiddingwebsite",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 获取公司介绍列表
function getcompIntroducelist(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getcompIntroducelist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 保存公司介绍信息
function updatecompIntroduce(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "updatecompIntroduce",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取三体系列表
function getfilelist(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getfilelist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 保存三体系信息
function updatefilemanage(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "updatefilemanage",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 上传导入的模板
function getcrmExprotMode(tableid, fileid, url) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getcrmExprotMode",
          userid: Cookies.get("userid-b"),
          tableid: tableid,
          fileid: fileid,
          url: url,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 检查导入表表头是否正确
function chkcrmTableForm(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "chkcrmTableForm",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 初始化导入历史并开始数据分析
function anlycrmsisExcelInf(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "anlycrmsisExcelInf",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 导入历史列表
function getcrmImpDataList(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getcrmImpDataList",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 删除费用单
function delUtilityBill(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "del",
          pagename: "delUtilityBill",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取区域列表
function getAreaLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getAreaLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取施工队列表
function getConstrTeamLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getConstrTeamLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 施工队编辑新增
function saveConstrTeaminfo(jsonstr, jsonstrfile) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "saveConstrTeaminfo",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          jsonstrfile: JSON.stringify(jsonstrfile),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取施工队详情
function getConstrTeamDetail(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getConstrTeamDetail",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取施工队队员列表
function getConstrTeamPersonLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getConstrTeamPersonLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取施工队队员详情
function getConstrTeamPerDetail(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getConstrTeamPerDetail",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取施工队队员新增编辑
function saveConstrTeamPerinfo(jsonstr, jsonstrfile) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "saveConstrTeamPerinfo",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          jsonstrfile: JSON.stringify(jsonstrfile),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 应收款报表-应收款列表
function getReportReceivables(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getReportReceivables",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 费用单列表详情
function getUtilityBillLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getUtilityBillLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 修改施工队 施工队员的退出时间
function saveConstrDtexitDate(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "saveConstrDtexitDate",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 修改施工队 施工队员的认证状态
function saveConstrExamStatus(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "saveConstrExamStatus",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 修改应收款的金额
function saveReportReceivableinf(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "saveReportReceivableinf",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 导出列表（施工队等）
function OutputTeamList(jsonstr, strTableId) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "outputTeamList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          strTableId: strTableId,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 取区域列表树形结构
function getAreaTree(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getAreaTree",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 组合记录表头（动态处理生成）
function getConstrCostHeard(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getConstrCostHeard",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 实发报表-判定组合是否已经使用
function getIsUsedcloumname(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getIsUsedcloumname",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 实发报表-历史记录列表
function getConstrCostLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getConstrCostLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 实发报表-历史记录详情数据列表
function getCostRecordsLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getCostRecordsLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 实发报表-生成自由组合的数据
function saveConstrCost(jsonstr, jsonstrcomb) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "saveConstrCost",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          jsonstrcomb: JSON.stringify(jsonstrcomb),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 施工队确认详情（通用）
function getCostRecordsdetail(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getCostRecordsdetail",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 施工队提交确认信息
function saveConstrComfirm(jsonstr, jsonstrcom) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "saveConstrComfirm",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          jsonstrcom: JSON.stringify(jsonstrcom),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取收款人信息
function getConstrTeamPayeelist(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getConstrTeamPayeelist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 修改组合记录的金额
function saveReportRecordsinf(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "saveReportRecordsinf",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 发送生成报表明细
function sendReportRecordsinf(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "sendReportRecordsinf",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取基本信息(服务状态)
function getbaseBaList(strbastype) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getbaseBaList",
          userid: Cookies.get("userid-b"),
          strbastype: strbastype,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 施工队编号是否已存在
function getIsUsedteamCode(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getIsUsedteamCode",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 判断施工队员编号是否已存在
function getIsUsedPersonCode(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getIsUsedPersonCode",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
function outputReportList(strTableId, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "outputReportList",
          userid: Cookies.get("userid-b"),
          strTableId: strTableId,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//结算核对汇总表列表
function getBillMonthLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getBillMonthLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//结算核对汇总表明细
function getBillMonthinfdetailList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getBillMonthinfdetailList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//施工队修改消息员
function saveTeamUserid(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "saveTeamUserid",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//施工队人员列表
function getTeamUserList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getTeamUserList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//发送核对账单
function sendBillMonthinf(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "sendBillMonthinf",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//----------------- 数字人聊天接口-----------------------
//发送聊天
function sendchatmsg(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIChat,
        qs.stringify({
          action: "edit",
          pagename: "sendchatmsg",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = JSON.parse(res.data);
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//取聊天列表
function getchatlist(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIChat,
        qs.stringify({
          action: "edit",
          pagename: "getchatlist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = JSON.parse(res.data);
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//取聊天标题
function getchattitel(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIChat,
        qs.stringify({
          action: "edit",
          pagename: "getchattitel",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = JSON.parse(res.data);
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//剩于对话次数
function getrestnumconversations(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIChat,
        qs.stringify({
          action: "edit",
          pagename: "getrestnumconversations",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = JSON.parse(res.data);
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//删除聊天标题
function delchat(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIChat,
        qs.stringify({
          action: "edit",
          pagename: "delchat",
          userid: Cookies.get("userid-b"),
          jsonstr: jsonstr,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = JSON.parse(res.data);
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//删除历史记录
function delConstrCost(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "del",
          pagename: "delConstrCost",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = res.data;
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//施工队实发收款人列表
function getCostRecordsdetailLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getCostRecordsdetailLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = res.data;
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//校验手机号是否重复
function checkJbTeamUser(chkval, useridr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "checkJbTeamUser",
          userid: Cookies.get("userid-b"),
          useridr: useridr,
          chkval: chkval,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = res.data;
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//保存修改人员信息
function saveJbTeamUserInfo(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "saveJbTeamUserInfo",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = res.data;
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//删除人员
function delJbTeamUser(useridr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "del",
          pagename: "delJbTeamUser",
          userid: Cookies.get("userid-b"),
          useridr: useridr,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = res.data;
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//取人员用户详情
function getTeamUserDetail(useridr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getTeamUserDetail",
          userid: Cookies.get("userid-b"),
          useridr: useridr,
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = res.data;
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//查询是否有导入权限--招聘管理
function getProjectImpSet(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getProjectImpSet",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = JSON.parse(res.data);
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//批量启动项目导入
function saveProjectImpSet(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "saveProjectImpSet",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = JSON.parse(res.data);
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//初始化导入历史并导入数据（到面 入职用）
function psnAnlysisExcelInfstatus(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "psnAnlysisExcelInfstatus",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res.status == 200) {
            let result = JSON.parse(res.data);
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//获取招聘导入模板下载路径
function getImportModeUrl(tableid, fileid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getPsnOutPutMode",
          userid: Cookies.get("userid-b"),
          tableid: tableid,
          fileid: fileid,
        })
      )
      .then((res) => {
        try {
          // if(res.status == 200){
          let res01 = JSON.parse(res.data);
          resolve(res01);
          // }else {
          //   resolve(false);
          // }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//上传招聘导入模板
function getpsnExprotModeSign(tableid, fileid, url) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getpsnExprotMode",
          userid: Cookies.get("userid-b"),
          tableid: tableid,
          fileid: fileid,
          url,
        })
      )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = JSON.parse(res.data);
            upmodeRes.status == "ok" ? resolve(true) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//猎头爬虫
// 认领
function addEntClaim(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "save",
          pagename: "addEntClaim",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = res.data;
            upmodeRes.status == "ok" ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 施工队重新认证列表
function getConstrTeamRecertif(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getConstrTeamRecertif",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = res.data;
            upmodeRes.status == "ok" ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 施工队列表提醒
function getConstrTeamremind(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getConstrTeamremind",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = res.data;
            upmodeRes.status == "ok" ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 施工队队员提醒
function getConstrTeamPersonremind(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "edit",
          pagename: "getConstrTeamPersonremind",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = res.data;
            upmodeRes.status == "ok" ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 施工队重新认证申请
function applyConstrTeamRecertif(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "applyConstrTeamRecertif",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = res.data;
            upmodeRes.status == "ok" ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 重新认证申请处理
function handleConstrTeamRecertif(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICust,
        qs.stringify({
          action: "save",
          pagename: "handleConstrTeamRecertif",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = res.data;
            upmodeRes.status == "ok" ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 资源库搜索 项目列表
function getproListsonwork(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getproListsonwork",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = JSON.parse(res.data);
            upmodeRes.status == "ok" ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 推送客户信息到CRM系统
function sendDataToCrm(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "sendDataToCrm",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = res.data;
            resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 资源库搜索 岗位列表
function getresourcejobcustomerlist(roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "apply",
          pagename: "getresourcejobcustomerlist",
          userid: Cookies.get("userid-b"),
          roletype: roletype,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = JSON.parse(res.data);
            upmodeRes.status == "ok" ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 取所有权限菜单（新版）
function baLLGetauthPowerInf(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "baLLGetauthPowerInf",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // upmodeRes.status == 'ok' ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 据登录的userid获取其权限菜单(不包括按钮)
function bgetLoginauthPowerInf(roleuserid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "bgetLoginauthPowerInf",
          userid: Cookies.get("userid-b"),
          roleuserid: roleuserid,
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes)
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 查询页面按钮
function getbtnPowerIdBypage(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getbtnPowerIdBypage",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // upmodeRes.status == 'ok' ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取角色列表
function bgetRoleauthList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "bgetRoleauthList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // upmodeRes.status == 'ok' ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 新增修改角色
function bupdateauthRoleList(jsonstr, powerlist) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "bupdateauthRoleList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          powerlist: powerlist,
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // upmodeRes.status == 'ok' ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 删除角色
function deleteRoleList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "del",
          pagename: "bupdateauthRoleList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data.msg);
            // let upmodeRes = JSON.parse(res.data)
            // upmodeRes.status == 'ok' ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取岗位列表
function bgetStationauthList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "bgetStationauthList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // upmodeRes.status == 'ok' ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 新增修改岗位
function bupdateauthStationList(jsonstr, powerlist) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "bupdateauthStationList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          powerlist: powerlist,
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // upmodeRes.status == 'ok' ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 删除岗位
function bdelauthStationList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "del",
          pagename: "bdelauthStationList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // upmodeRes.status == 'ok' ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//取利润报表特殊权限用户列表
function getauthUserBasicReport(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getauthUserBasicReport",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//新增/删除利润报表用户列表
function upuserBasicReport(data) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "upuserBasicReport",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(data),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 用户列表新
function getauthUserInfoByorgancode(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getauthUserInfoByorgancode",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // upmodeRes.status == 'ok' ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 取用户详情新
function getauthJbUserDetail(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getauthJbUserDetail",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          // console.log('res',res)
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 新增修改用户信息新
function updateauthJbUserInfo(accoutInfo, powerlist) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "updateauthJbUserInfo",
          userid: Cookies.get("userid-b"),
          accoutInfo: JSON.stringify(accoutInfo),
          powerlist: powerlist,
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // upmodeRes.status == 'ok' ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 修改在离职重置密码新
function Resetpwdmodifysta(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "Resetpwdmodifysta",
          userid: Cookies.get("userid-b"),
          accoutInfo: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // upmodeRes.status == 'ok' ? resolve(upmodeRes) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 据登录的userid获取其权限菜单(不包括按钮--切换账号用)
function bgetLoginauthPowerInfChange(userid, roleuserid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "bgetLoginauthPowerInf",
          userid: userid,
          roleuserid: roleuserid,
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes)
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 去签约模板列表
function getContractList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "edit",
        pagename: "getContractList",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 导出项目签约汇总
function getMonthlyEconSummary(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "getMonthlyEconSummary",
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 获取批量发送短信进度
function getAsyncBatchSendProgress(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "getAsyncBatchSendProgress",
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//  取上上签单点登陆URL
function getBestSingnSOSUrl(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "edit",
        pagename: "getBestSingnSOSUrl",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//  下载电子签约合同模板
function getTempCombined(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "getTempCombined",
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  根据项目查已配置好的模板列表
function templatesByProjectList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "templatesByProjectList",
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  去电子签约
function submitESigningInfo(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "submitESigningInfo",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  确认线下签约
function addOfflineSigning(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "edit",
        pagename: "addOfflineSigning",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  扫码报名
function SubmitEcon(name, PhoneNum, strIdCard, id, Bankcard, Address, Education, DepositBank) {
  return new Promise(resolve => {
    axios.post(
      APIEcon + '/Econ/SubmitEcon',//正式需要额外加一个 /Econ
      // APIEcon + '/SubmitEcon',
      qs.stringify({
        name,
        PhoneNum,
        strIdCard,
        id,
        Bankcard,
        Address,
        Education,
        DepositBank
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  下载合同
function getBestSingndownloadfile(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "getBestSingndownloadfile",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

// 获取二维码报名列表
function econQRCodeRegisList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "econQRCodeRegisList",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  删除审批数据
function delContractAppro(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "del",
        pagename: "delContractAppro",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  审批通过/不通过
function contracttApproval(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "edit",
        pagename: "contracttApproval",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  获取签约信息
function getContractListByPhone(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "getContractListByPhone",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//  确认发送短信
function sendtextMessagesContracts(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "edit",
        pagename: "sendtextMessagesContracts",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  重新发送短信
function contractsRemind(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "contractsRemind",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//  导入签约表
function batchImportQuery(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "batchImportQuery",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//  删除模板
function delComtractTemp(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "del",
        pagename: "delComtractTemp",
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  新增模板分配
function updataContractTemp(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "edit",
        pagename: "updataContractTemp",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  取签约主体列表
function getLegalSubjectList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "edit",
        pagename: "getLegalSubjectList",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data.replace(/null(?=\s*}$)/, '')));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  生成新码
function generateEConQRCode(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "generateEConQRCode",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}



//  下载电子签约合同模板
function GetTempListEmployee1(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "edit",
        pagename: "GetTempListEmployee1",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  获取合同审批列表
function getContractApproList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "edit",
        pagename: "getContractApproList",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  归档
function placefileContracts(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "placefileContracts",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//  停用二维码
function qrCodeDeactivation(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "qrCodeDeactivation",
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  下载导入模板
function getImportTemplate(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "edit",
        pagename: "getImportTemplate",
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//  修改签约手机号码
function modifyMobilePhone(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "modifyMobilePhone",
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//  下载导入签约表模板
function getImportSigningTableTemplate(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "getImportSigningTableTemplate",
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//审批通过
function customerServiceApproved(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: 'customerServiceApproved',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 批量导入线下签约 excel
function offlineSigningImportTemplate(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIEcon,
      qs.stringify({
        action: "save",
        pagename: "offlineSigningImportTemplate",
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 根据主体名称获取主体详情
function getLegalSubjec(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICrm,
      qs.stringify({
        action: "edit",
        pagename: 'getLegalSubjec',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve((res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

// 获取险种列表
function getInsurancManageList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getInsurancManageList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 获取险种详情
function getInsurancManage(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getInsurancManage',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 新增修改险种
function editInsurancManage(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'editInsurancManage',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 险种停用/启用
function editInsurancManageEnabled(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'editInsurancManageEnabled',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 删除启用
function delInsurancManage(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "del",
        pagename: 'delInsurancManage',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

// 获取服务商列表
function getServiceProviderList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getServiceProviderList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 生成保单号
function BuildOrder(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'BuildOrder',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 核对名单列表
function BuildCheckList(jsonstr, roletype, pagename) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename,
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
function BuildTime(pagename, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename,
        userid: Cookies.get("userid-b"),
        jsonstr: '',
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除服务商
function delServiceProvider(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "del",
        pagename: 'delServiceProvider',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取审核人列表
function getAuditorSetupList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getAuditorSetupList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除审核人
function delAuditorSetup(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "del",
        pagename: 'delAuditorSetup',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 新增/编辑商保审核人
function editAuditorSetup(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'editAuditorSetup',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 新增/编辑服务商
function editServiceProvider(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'editServiceProvider',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取自己可取到险种列表
function getInsurancManageByUserid(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getInsurancManageByUserid',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//报增/报减
function reportAddApprov(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'reportAddApprov',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取自己一个周期内是否有点过
function getReminderTag(roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getReminderTag',
        userid: Cookies.get("userid-b"),
        jsonstr: '',
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//自己一个周期提示打卡
function doReminderTag(roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'doReminderTag',
        userid: Cookies.get("userid-b"),
        jsonstr: '',
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//修改在保名单手机号
function updataPhoneIninsurance(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'updataPhoneIninsurance',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//审批者取自己能审批单子
function getApprovalByUserId(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getApprovalByUserId',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 获取在保名单
function getInsuredPersonsList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getInsuredPersonsList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 在保名单报减
function ReportReduce(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'ReportReduce',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取缴费名单
function getMasterList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getMasterList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//确认名单
function doMasterList(roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'doMasterList',
        userid: Cookies.get("userid-b"),
        jsonstr: '',
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 上传商保模板
function templateFileUpload(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'templateFileUpload',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 退回明细个人编辑
function updataApprovalDetail(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'updataApprovalDetail',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 删除退回明细个人
function delApprovalDetail(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "del",
        pagename: 'delApprovalDetail',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 重新提交审批
function submitApproval(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'submitApproval',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 保司失败重新提交审批
function ReSubmitFail(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'ReSubmitFail',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 通过认证
function PassApplyInfo(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'PassApplyInfo',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
function UpdateApplyInfo(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'UpdateApplyInfo',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//获取待审核/退回/通过列表
function getApprovalByProjectPower(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getApprovalByProjectPower',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取自己可取到险种列表
function applyInsured(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'applyInsured',
        userid: Cookies.get("userid-b"),
        jsonstr: '',
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//查看明细
function getApprovalDetails(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getApprovalDetails',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//查看明细
function insuranceH5(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APIJins + '/insuranceH5',
      qs.stringify({
        jsonstr: JSON.stringify(jsonstr),
      })
    )
      .then((res) => {
        try {
          resolve((res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出保司明细
function GetApprovalSuccess(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'GetApprovalSuccess',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//商保提交记录
function SubmitList(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'SubmitList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//审批通过
function approvalEnd(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'approvalEnd',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//报增/减 退回
function approvalReturn(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'approvalReturn',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//理赔报案列表
function getInsureClaimList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getInsureClaimList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//获取审批进度
function getApprovalProgress(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getAsyncBatchSendProgress',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//确认名单进度
function getAsyncApplyInsuredProgress(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getAsyncApplyInsuredProgress',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//获取订单/保单
function getOrderPolicyManageList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getOrderPolicyManageList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//批量报增下载模板
function getInsureImportTemplate(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getInsureImportTemplate',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//取客服部工伤事故报告列表
function getWIAccidentReportList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWIAccidentReportList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//新增 修改 客服部工伤事故报告
function updataWIAccidentReport(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'updataWIAccidentReport',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取客服部工伤事故报告详情
function getWIAccidentReport(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWIAccidentReport',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取客服部-工伤手续办理列表
function getWiserviceList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiserviceList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//新增/修改客服部-工伤手续办理
function updataWiservice(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'updataWiservice',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取客服部-工伤手续办理详情
function getWiserviceReport(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiserviceReport',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除客服部-工伤手续办理
function delWiservice(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "del",
        pagename: 'delWiservice',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取保险组-工伤手续办理列表
function getWiinsuranceGroup3List(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiinsuranceGroup3List',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取【3】保险组-工伤手续办理详情
function getWiinsuranceGroup3(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiinsuranceGroup3',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//新增/修改保险组-工伤手续办理
function updataWiinsuranceGroup3(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'updataWiinsuranceGroup3',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除【3】保险组-工伤手续办理详情
function delWiinsuranceGroup3(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "del",
        pagename: 'delWiinsuranceGroup3',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出报告
function exportInjuryReport(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'exportInjuryReport3',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取【4】保险组-工伤平账列表
function getWiinsuranceGroupReconc4List(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiinsuranceGroupReconc4List',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取保险组-工伤平账详情
function getWiinsuranceGroupReconc4(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiinsuranceGroupReconc4',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//新增修改【4】保险组-工伤平账
function updataWiinsuranceGroupReconc4(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'updataWiinsuranceGroupReconc4',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除【4】保险组-工伤平账详情
function delWiinsuranceGroupReconc4(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "del",
        pagename: 'delWiinsuranceGroupReconc4',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取【5】保险组-工伤数据分析列表
function getWiinsuranceGroupDa5List(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiinsuranceGroupDa5List',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取【5】保险组-工伤数据分析详情
function getWiinsuranceGroupDa5(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiinsuranceGroupDa5',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//新增修改【5】保险组-工伤数据分析
function updataWiinsuranceGroupDa5(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'updataWiinsuranceGroupDa5',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除【5】保险组-工伤数据分析详情
function delWiinsuranceGroupDa5(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "del",
        pagename: 'delWiinsuranceGroupDa5',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取【6】赔付明细1-社保列表
function getWiclaimDetails1Ss6List(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiclaimDetails1Ss6List',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取【6】赔付明细1-社保详情
function getWiclaimDetails1Ss6(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiclaimDetails1Ss6',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//新增修改【6】赔付明细1-社保
function updataWiclaimDetails1Ss6(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'updataWiclaimDetails1Ss6',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除【6】赔付明细1-社保详情
function delWiclaimDetails1Ss6(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "del",
        pagename: 'delWiclaimDetails1Ss6',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取【7】赔付明细2-商保1列表
function getWiclaimDetails2Bi7List(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiclaimDetails2Bi7List',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取【7】赔付明细2-商保1详情
function getWiclaimDetails2Bi7(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiclaimDetails2Bi7',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//新增修改【7】赔付明细2-商保1
function updataWiclaimDetails2Bi7(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'updataWiclaimDetails2Bi7',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除【7】赔付明细2-商保1详情
function delWiclaimDetails2Bi7(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "del",
        pagename: 'delWiclaimDetails2Bi7',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取【8】赔付明细3-商保2列表
function getWiclaimDetails3Bi8List(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiclaimDetails3Bi8List',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取【8】赔付明细3-商保2详情
function getWiclaimDetails3Bi8(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWiclaimDetails3Bi8',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//新增修改【8】赔付明细3-商保2
function updataWiclaimDetails3Bi8(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'updataWiclaimDetails3Bi8',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除【8】赔付明细3-商保2详情
function delWiclaimDetails3Bi8(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "del",
        pagename: 'delWiclaimDetails3Bi8',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 识别图片
function distinguishImg(data) {
  return new Promise((resolve) => {
    axios
      .post(location.origin + '/MobImg', data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        resolve(res.status === 200 ? res.data : false);
      });
  });
}
// H5二维码项目岗位保存
function H5ProjectOption(data,pagename) {
  return new Promise((resolve) => {
    axios
      .post(location.origin + '/BRole/BRole/'+ pagename, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        resolve(res.status === 200 ? res.data : false);
      });
  });
}

function H5ProjectInfo(data) {
  return new Promise((resolve) => {
    axios
      .post(location.origin + '/BRole/BRole/H5ProjectInfo', data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        resolve(res.status === 200 ? res.data : false);
      });
  });
}
function PostOcrbd(data) {
  return new Promise((resolve) => {
    axios
      .post(location.origin + '/BRole/BRole/PostOcrbd', data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        resolve(res.status === 200 ? res.data : false);
      });
  });
}
function GetBdToken() {
  return new Promise((resolve) => {
    axios
      .post(location.origin + '/BRole/BRole/GetBdToken', {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        resolve(res.status === 200 ? res.data : false);
      });
  });
}
//根据身份证号获取信息
function getWorkAccidentProjectById(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getWorkAccidentProjectById',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//OA数据同步
function getOACostDetail(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'getOACostDetail',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 取所有项目列表
function getProjectAllLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getProjectAllLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//取到款列表
function getAccountingRecordsList(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getAccountingRecordsList',
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//创建认领
function addClaimRecord(jsonstr, roletype,pagename) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename,
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//认领记录列表
function getClaimRecordList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getClaimRecordList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//修改归属月
function claimSpecifiedMonth(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'claimSpecifiedMonth',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//撤销认领
function revocationClaimRecord(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'revocationClaimRecord',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//A28新增到款
function addNewMoneyReceived(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'addNewMoneyReceived',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//导入到账
function importToCbsRtnAmt(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'importToCbsRtnAmt',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//A10新增更新到款银行
function updataCollectingBank(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'updataCollectingBank',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取套账详情
function getProAccountSetDetail(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getProAccountSetDetail',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除到款银行
function delCollectingBank(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "del",
        pagename: 'delCollectingBank',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//启用/停用
function updataCollectingBankstateStr(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'updataCollectingBankstateStr',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//新增更新开票抬头表
function updataInvoiceTitle(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'updataInvoiceTitle',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除开票抬头表
function delInvoiceTitle(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "del",
        pagename: 'delInvoiceTitle',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//新增更新发薪主体
function updataPayMaster(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'updataPayMaster',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除发薪主体
function delPayMaster(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "del",
        pagename: 'delPayMaster',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//修改薪酬相关
function updataProAccountSet(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'updataProAccountSet',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//取公司财务设置
function getCompfinanceSet(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getCompfinanceSet',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//创建更新公司财务设置
function addCompfinanceSet(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'addCompfinanceSet',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//新增落地公司
function addDistributionChannel(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'addDistributionChannel',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//发放途径列表
function getDistributionChannelList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getDistributionChannelList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//申请发薪列表
function getApplicationPayrollList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getApplicationPayrollList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//申请发薪列表
function getApplicationPayrollList95(jsonstr, roletype,pagename) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: pagename!=undefined ? pagename :'getApplicationPayrollList95',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//暂支电子回单
function getElectroniAdvPayment(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    Id: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getElectroniAdvPayment',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//直接打款 电子回单
function getElectroniAdvDirectCaym(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    Id: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getElectroniAdvDirectCaym',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//下载电子回单按发薪编号
function downloadEleReceiptPayNum(data) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'downloadEleReceiptPayNum',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//下载电子回单按发薪编号
function DownloadEleReceiptByAttrMonth(data) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'DownloadEleReceiptByAttrMonth',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//申请发薪列表数量
function getApplicationPayrollListCount(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getApplicationPayrollListCount',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//申请发薪列表数量
// function getApplicationPayrollListCount95(jsonstr, roletype) {
//   let data = {
//     userid: Cookies.get("userid-b"),
//     roletype: roletype,
//     parmjsonstr: JSON.stringify(jsonstr)
//   }
//   return new Promise(resolve => {
//     axios.post(
//       APICbs,
//       qs.stringify({
//         action: "edit",
//         pagename: 'getApplicationPayrollListCount95',
//         jsonstr: JSON.stringify(data)
//       })
//     )
//       .then((res) => {
//         try {
//           resolve(JSON.parse(res.data));
//         } catch (e) {
//           resolve(false)
//         }
//       })
//   })
// }
function getApplicationPayrollListCount95(jsonstr) {
     let data = {
     jsonpamrm: JSON.stringify(jsonstr)
   }
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/getApplicationPayrollListCount951',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取成功列表
function getSucceedToPaylList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getSucceedToPaylList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取失败列表
function getFailedDetaiOrToPaylList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getFailedDetaiOrToPaylList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//批量提交
function financeFailureProcessing(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'financeFailureProcessing',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//发薪失财人员归档
function failurePayToArchive(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'failurePayToArchive',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//失败人员重新打款
function failurePayAgain(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'failurePayAgain',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//修改打款失败人员信息
function modifyPaymentFailure(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'modifyPaymentFailure',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

function DownloadEleReceiptPayNum(date) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'DownloadEleReceiptPayNum',
        jsonstr: JSON.stringify(date)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//A01新增申请发薪
function addApplicationPayroll(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'addApplicationPayroll',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//
function CheckPerson(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'CheckPerson',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//A07申请发薪详情
function getApplicationPayrollDetail(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getApplicationPayrollDetail',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//查询校验、算税状态
function getApplicationPayrollDetailN1(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getApplicationPayrollDetailN1',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//线下发薪导出明细
function ExpOfflinePayrollList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'ExpOfflinePayrollList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//0收入补录
function ZeroRepair(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'ZeroRepair',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//0收入算税
function ZeroRepairTax(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'ZeroRepairTax',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//预支工资批量填写系统数据
function BatchFillSystemDataAdvanceWages(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'BatchFillSystemDataAdvanceWages',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//当前项目是否在算税
function CheckTaxState(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'CheckTaxState',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//薪福通异常列表
function getExList(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getExList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//薪福通异常登记处理
function ExOption(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'ExOption',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//拷贝到数字化
function RecoverSys(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'RecoverSys',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//薪福通重算
function RecoverXft(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'RecoverXft',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//0收入列表
function ZeroRepairList(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'ZeroRepairList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//0收入补录作废
function CancellApplication(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'CancellApplication',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//暂扣人员列表
function getTempSuspList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getTempSuspList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//暂扣人员发薪
function withSubmitPay(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'withSubmitPay',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//发薪原始表数据
function getOriginalImportDetail(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getOriginalImportDetail',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//A30更新申请发薪
function updataApplicationPayroll(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'updataApplicationPayroll',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//退款列表
function getRefundList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getRefundList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//登记退款
function registerRefund(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'registerRefund',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//到款-下载回单
function getElectronicReceiptPayment(data) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getElectronicReceiptPayment',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//检查当前项目月提交明细
function checkCurrentProjectSubmiTdetails(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'checkCurrentProjectSubmiTdetails',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//算薪状态从草稿变算薪
function draftBecomesSalary(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'draftBecomesSalary',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取垫支账户列表
function getAllLegalAccount(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getAllLegalAccount',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//暂支打款
function cbsPayAdvance(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'remitAdvance',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//暂支合作账户打款
function remitAdvance3(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'remitAdvance3',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//暂扣人员信息修改
function modifyTempSuspInfo(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'modifyTempSuspInfo',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//安排资金列表
function appropriatFundsList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "save",
        pagename: 'appropriatFundsList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//算税未成功列表
function getUnsuccessfulTaxList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getUnsuccessfulTaxList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//A删除申请发薪
function cancellApplication(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'cancellApplication',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//登记手工打款成功
function registerRemitSuccess(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'registerRemitSuccess',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//登记手工打款失败
function registerRemitFail(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'registerRemitFail',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//发薪失败登记手工打款成功/失败
function FailurePayAgainHandMade(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'FailurePayAgainHandMade',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//一单中全部的发薪公司列表
function getPayrollCompanyList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getPayrollCompanyList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//判断是否是财务
function IsFinancial(roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: ''
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'IsFinancial',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//财务  获取项目列表
function GetFinancialProject(roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: ''
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'GetFinancialProject',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//税局个税获取
function taxBureauPersonalTaxAcquisition(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'taxBureauPersonalTaxAcquisition',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//重新算税
function recalculate(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'recalculate',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取审批数量
function getOAHomeInit(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'workTableTodoneTotalnum',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取审批列表
function getOATodolist(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getOATodolist',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出列表
function payrollApplicationExport(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'payrollApplicationExport',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出算税列表
function exportTaxCalcuResultDetail(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'exportTaxCalcuResultDetail',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出结算单算税结果原始数据
function ExportSettTaxResult(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'ExportSettTaxResult',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取导入线下发薪数据列表
function getImportOfflinePayrollList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getImportOfflinePayrollList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取已审批/我发起的 列表
function WFSearch(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'WFSearch',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//审批同意
function aOapiNodeSendWork(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'aOapiNodeSendWork',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//审批不同意
function AOapiNodeReturnWork(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'AOapiNodeReturnWork',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取工作流
function getGenerWorkerList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getGenerWorkerList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取模板表头
function getExcelHeadByUrl(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getExcelHeadByUrl',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取系统默认字段
function getImportTempDetail(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getImportTempDetail',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除模板
function delImportTemp(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'delImportTemp',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//终止校验
function StopCheck(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    id: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'StopCheck',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//终止算税
function StopTax(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    id: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'StopTax',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导入线下发薪数据
function importOfflinePayrollData(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'importOfflinePayrollData',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//新增修改模板
function addUpdataImportTempList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'addUpdataImportTempList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取模板列表
function getImportTempList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getImportTempList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//出纳确认
function cashierFinancialAudit(jsonstr, roletype,pagename) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename,
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//发薪子公司银行账户
function selectPayrollBankAccount(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'selectPayrollBankAccount',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//打款
function cbsRemit(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'cbsRemit',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//线下登记
function addOfflineInTaxDecl(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'addOfflineInTaxDecl',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//线下登记列表
function getOfflineInTaxDeclList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getOfflineInTaxDeclList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取PayReferenceNum
function getPayReferenceNumStrs(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getPayReferenceNumStrs',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//公司会计取全部法务主体
function getInternalCompNameList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getInternalCompNameList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//人员税局登记
function sendusertoxft(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "save",
        pagename: 'sendusertoxft',
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取个税
function sendusertax(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "save",
        pagename: 'sendusertax',
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取整批个税
// function senduserlisttax(jsonstr) {
//   return new Promise(resolve => {
//     axios.post(
//       APICbs,
//       qs.stringify({
//         action: "edit",
//         pagename: 'senduserlisttax',
//         jsonstr: JSON.stringify(jsonstr)
//       })
//     )
//       .then((res) => {
//         try {
//           resolve(JSON.parse(res.data));
//         } catch (e) {
//           resolve(false)
//         }
//       })
//   })
// }

function senduserlisttax(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    // axios({
    //   method: 'post',
    //   url: APICbsTc + '/ApplySalary/SendlserListTax',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   data
    // })
    axios.post(
      APICbsTc + '/ApplySalary/senduserlisttax?strjson=' + data,
    )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

// //整批税局登记
// function senduseralltoxft(jsonstr) {
//   return new Promise(resolve => {
//     axios.post(
//       APICbs,
//       qs.stringify({
//         action: "edit",
//         pagename: 'senduseralltoxft',
//         jsonstr: JSON.stringify(jsonstr)
//       })
//     )
//       .then((res) => {
//         try {
//           resolve(JSON.parse(res.data));
//         } catch (e) {
//           resolve(false)
//         }
//       })
//   })
// }

function senduseralltoxft(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    // axios({
    //   method: 'post',
    //   url: APICbsTc + '/ApplySalary/SendUserALLToXFT',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   data
    // })
    axios.post(
      APICbsTc + '/ApplySalary/SendUserALLToXFT?strjson=' + data,
    )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//整批税局登记
function sendUserALLToXFTDeclartion(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/ApplySalary/sendUserALLToXFTDeclartion',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })

      .then((res) => {
        try {
          resolve((res.data));
        } catch (e) {
          console.log(e)
          resolve(false)
        }
      })
  })
}

//整批税局算税
function sendUserListTaxDeclartion(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/ApplySalary/sendUserListTaxDeclartion',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })

      .then((res) => {
        try {
          resolve((res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//RC通用方法
function rcFun(jsonstr,pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: 'https://emp.joball.net/rc/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })

      .then((res) => {
        try {
          resolve((res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//rc通用GET方法
function rcGetFun(str) {
  return new Promise(resolve => {
    axios({
      method:'get',
      url: 'https://emp.joball.net/rc/' + str,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//rc导出通用方法
function rcExpFun(jsonstr,pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: 'https://emp.joball.net/rc/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve((res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//ApplySalary通用方法
function ApplySalaryFun(jsonstr,pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/ApplySalary/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })

      .then((res) => {
        try {
          resolve((res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//ApplySalary导出通用方法
function ApplySalaryExpFun(jsonstr,pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/ApplySalary/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve((res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//下载回单 整批的
function getpayaccstr(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getpayaccstr',
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//下载回单 单个的
function getpaylistacc(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getpaylistacc',
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//下载回单 单个的
function getpdfcont(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getpdfcont',
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//取企业登记序号
function getreqseq(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getreqseq',
        jsonstr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//撤销
function withdrawClaim(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'withdrawClaim',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//修改关联到款
function modifyAssociatedPayment(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'modifyAssociatedPayment',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//查询所得明细列表
function GetIncomePageList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeDetail/GetIncomePageList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//全部人员列表/零申报人员列表
function GetIncomePersonPageList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeDetail/GetIncomePersonPageList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取错误信息
function GetErrorMsgPageList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeDetail/GetErrorMsgPageList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除人员所得（人员
function DeleteInComeDetail(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'DELETE',
      url: APICbsTc + '/IncomeDetail/DeleteInComeDetail',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除人员所得（项目）
function DeleteIsZeroInComeDetail(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'DELETE',
      url: APICbsTc + '/IncomeDetail/DeleteIsZeroInComeDetail',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导入个税所得明细
function ImportInComeDetail(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeDetail/ImportInComeDetail',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出个税所得明细
function ExportInComeDetail(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeDetail/ExportInComeDetail',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出人员列表/零申报列表
function ExportInComePersonalDetail(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeDetail/ExportInComePersonalDetail',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出个税草稿列表  公司
function ExportIncomeBatchPageList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/ExportIncomeBatchPageList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出暂支列表 
function ExportAdvanceList(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出算税错误洗选煤
function expErrInfo(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出扣除信息/预扣实缴差异列表
function ExportSpecialDeductionPageList(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出申报公司列表
function ExportInComeDeclarePageList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/ExportInComeDeclarePageList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出个税草稿列表  项目
function ExportBatchProjectList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/ExportBatchProjectList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//导出个税草稿全部人员/零申报列表
function ExportBatchPersonList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/ExportBatchPersonList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

// 导出待确认列表（公司）
function ExportBatchCompanyList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/ExportBatchCompanyList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//导出待确认项目列表
function ExportWaitingBatchProjectPageList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/ExportWaitingBatchProjectPageList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//导出待确认全部人员/零申报人员
function ExportBatchDetailPersonPageList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/ExportBatchDetailPersonPageList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//导出
function exportTaxList(pagename, jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//RPA导出通用
function exportRPA(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/RPA/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取专项扣除列表
function GetSpecialDeductionPageList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/GetSpecialDeductionPageList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//获取设置的申报公司列表
function GetInComeDeclarePageList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/GetInComeDeclarePageList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//选择全部公司申报
function SetAllCompanyDeclare(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/SetAllCompanyDeclare',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//选择申报 /不申报
function SetInComeDeclarationSetting(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/SetInComeDeclarationSetting',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取申报时间
function GetInComeTimeSetting(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/IncomeBatch/GetInComeTimeSetting',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//设置申报时间
function SetInComeTimeSetting(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/SetInComeTimeSetting',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//修改前的发起校验
function StartPersonalCheck(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeDetail/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//查询校验状态
function PullInComeStatusNotDeclare(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//发起算税
function CheckCacuTaxInComeDetailNotDeclare(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//查询算税状态
function PullInComeTaxCacuStatusNotDeclare(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//修改所得明细
function CreateOrEditInComeDetail(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeDetail/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//设置算税结果
function SetCalculateTax(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeDetail/SetCalculateTax',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//设置校验结果
function SetPersonnelCheck(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeDetail/SetPersonnelCheck',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//设置校验结果 (全部人员修改)
function SetAllPersonnelOrZeroCheck(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeDetail/SetAllPersonnelOrZeroCheck',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//设置算税结果 (全部人员修改)
function SetAllPersonalOrZeroCalculateTax(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeDetail/SetAllPersonalOrZeroCalculateTax',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取个税草稿列表
function getDataList(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      timeout: 120 * 10000,
      url: APICbsTc + '/IncomeBatch/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//生成批次前的发起 校验
function CheckBuildInComeDetailBatch(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/CheckBuildInComeDetailBatch',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//申报前的发起 校验
function GetApplyInComeCheckList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/GetApplyInComeCheckList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//查询校验状态
function PullInComeStatus(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/PullInComeStatus',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//生成批次前的发起 算税
function CheckCacuTaxInComeDetailBatch(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/CheckCacuTaxInComeDetailBatch',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//查询算税状态
function PullInComeTaxCacuStatus(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/PullInComeTaxCacuStatus',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//生成批次
function BuildInComeDetailBatch(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/BuildInComeDetailBatch',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//确认提交
function SetInComeDetailBatchStatus(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/SetInComeDetailBatchStatus',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//撤销
function DismissInComeBatchStatus(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/DismissInComeBatchStatus',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取待申报项目列表
function GetDeclarationProjectPageList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/GetDeclarationProjectPageList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//申报/重新申报
function ApplyIncomeDeclaration(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/ApplyIncomeDeclaration',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}


//待确认-确认公司人员个税(按公司、项目、人员 确认 pagename区分)
function SetInComeBatchStatus(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}

//N01暂支代打款列表
function GetAdvancePageList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/GetAdvancePageList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
function GetAllLowUser(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetAllLowUser?Userid=' + id,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N02手动打款成功或打款失败
function remitAdvance(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/remitAdvance',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//直接打款
function directPaymentSubmit(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'directPaymentSubmit',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N12暂支详情
function GetAdvancesDetail(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/GetAdvancesDetail',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N10导入线下打款信息
function ImportOfflinePayment(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/ImportOfflinePayment',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//保存新增报销单
function addUpdataAdvanceVerif(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/addUpdataAdvanceVerif',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取暂支报销详情
function GetWriteoffDetail(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/GetWriteoffDetail',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//advid获取busid
function GetJbBusiaAdvLogWritFinans(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetJbBusiaAdvLogWritFinans?Id=' + id,
      headers: {
        'Content-Type': 'application/json','Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N55取报销编号
function GetAdvOrderCode(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetAdvOrderCode?Id=' + id,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取报销人银行卡信息
function GetAdvPaymenCard(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetAdvPaymenCard?Userid=' + id,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N07核销部门审核 核销部门审核/财务核销审批或退回
function VerifiDepartAudit(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/VerifiDepartAudit',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取审批流
function GetApprovalList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/GetApprovalList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//收支通用方法
function AdvanceFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//Advance通用GET方法
function AdvanceGetFun(str) {
  return new Promise(resolve => {
    axios({
      method:'get',
      url: APICbsTc + '/Advance/' + str,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//收支导出通用方法
function AdvanceExpFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
function GetBankStatFieldMatching() {
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/ArdCurStat/GetBankStatFieldMatching?input=ddd',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//客户在线通用方法
function ReportFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Report/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//社保通用方法
function SocialFun(jsonstr, pagename,method) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method,
      url: APICbsTc + '/Social/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//社保导出通用方法
function SocialExpFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Social/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//开票配置通用方法
function BasicFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APIBasic + '/BasicInformation/' + pagename,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//开票通用方法
function IvoiceFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APIIvoice + '/Ivoice/' + pagename,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//开票导出通用
function IvoiceEXPFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APIIvoice + '/Ivoice/' + pagename,
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//SR通用方法
function SRFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: 'https://emp.joball.net/' + 'cs/SubjectRelated/' + pagename,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//sr通用GET方法
function SRGetFun(str,method) {
  return new Promise(resolve => {
    axios({
      method,
      url: 'https://emp.joball.net/' + 'cs/SubjectRelated/' + str,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//SR导出通用
function SREXPFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: 'https://emp.joball.net/' + 'cs/SubjectRelated/' + pagename,
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//RPA通用方法
function RPAFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/RPA/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//rpa删除
function RPAdel(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'delete',
      url: APICbsTc + '/RPA/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取任务缺省设置
function GetTaskDefaultConfiguration(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/RPA/GetTaskDefaultConfiguration',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//开票批量下载
function DownLoadInv(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APIIvoice + '/Ivoice/DownLoadInviceFile/download',
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取获取开票方式
function GetProjectEmailList(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIBasic + '/BasicInformation/GetProjectEmailList?ProjectId=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取开票预设列表
function GetProjectInvoiceContentList(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIBasic + '/BasicInformation/GetProjectInvoiceContentList?ProjectId=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取获取开票方式
function GetBillingItem(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/GetBillingItem?SubjectOfLegalAffairsId=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//查询公司信息
function GetCorporationData(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/GetCorporationData?Legalsubid=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//发票申请查看
function GetInvoiceApplyForView(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/GetInvoiceApplyForView?InvoiceId=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//发票申请修改获取详情
function GetInvoiceEdit(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/GetInvoiceEdit?Id=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//发票申请修改获取详情
function GetInvoiceEditDetails(id, IsPolymerization) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/GetInvoiceEditDetails?Id=' + id + '&IsPolymerization=' + IsPolymerization,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//作废红冲查看
function GetRedPunchAlreadyInvoiceView(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/GetRedPunchAlreadyInvoiceView?Id=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//二维码扫码状态
function PostThirdParty_queryAuthQrCode(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/PostThirdParty_queryAuthQrCode?rzid=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取票种 申请
function GetTicketTypeForInvoice(id, iskc) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/GetTicketTypeForInvoice?SubjectOfLegalAffairsId=' + id + '&iskc=' +
        iskc,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取开票内容 申请
function GetBillingItemDetailsForInvoice(id, val, Projectid, iskc) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/GetBillingItemDetailsForInvoice?SubjectOfLegalAffairsId=' + id + '&TicketTypeId=' + val + '&Projectid=' + Projectid + '&iskc=' + iskc,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//已开票查看
function GetAlreadyInvoiceView(id, pagename) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/' + pagename + '?Id=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取开票内容
function GetBillingItemDetails(data) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/GetBillingItemDetails?BillingItemId=' + data.key + '&TicketTypeId=' + data.TicketTypeId + '&Projectid=' + data.Projectid,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取票种
function GetTicketType(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/GetTicketType?BillingItemId=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//修改结算单获取详情
function GetFinalStatementEdit(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/GetFinalStatementEdit?Id=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//修改票种获取详情
function GetTicketTypeEdit(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIBasic + '/BasicInformation/GetTicketTypeEdit?Id=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//特殊主体列表查询
function GetSpecialSubjectList(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIBasic + '/BasicInformation/GetSpecialSubjectList?SubjectOfLegalAffairsId=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//修改开票项目获取详情
function GetBillingItemEdit(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIBasic + '/BasicInformation/GetBillingItemEdit?Id=' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//Basic通用GET方法
function BasicGetFun(str,method) {
  return new Promise(resolve => {
    axios({
      method: method!=undefined && method ? method :'get',
      url: APIBasic + '/BasicInformation/' + str,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//AIbasic通用方法
function AIbasicFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: 'https://emp.joball.net/AiBasic/AI/Basic/' + pagename,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//TaskSetup通用方法
function TaskSetupFun(jsonstr, pagename) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: 'https://emp.joball.net/tsai/TaskSetup/' + pagename,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//TaskSetup通用GET方法
function TaskSetupGetFun(str,method) {
  return new Promise(resolve => {
    axios({
      method: method!=undefined && method ? method :'get',
      url:  'https://emp.joball.net/tsai/TaskSetup/' + str,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//Ivoice通用GET方法
function IvoiceGetFun(str) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APIIvoice + '/Ivoice/' + str,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//32检查上个月是否使用系统算税
function GetRiskAlertResultById(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetRiskAlertResultById?id=' + id,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N76财务数据源采集启动
function FinancialDataSourcesSystem(data) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/FinancialDataSourcesSystem?AttrMonth=' + data.AttrMonth + '&way=' + data.way + '&UserId=' + Cookies.get("userid-b"),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N78取财务数据源自动采集设置
function GetFinancialDataSourcesSettings(pagename) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/' + pagename,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//发送验证码
function SendPayRiskVerifCode(id, UserId) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/SendPayRiskVerifCode?id=' + id + '&UserId=' + UserId,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//get通用方法
function ArdCurStatGetFun(pagename, str) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/ArdCurStat/' + pagename + str,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//get通用下载
function ArdCurStatGetFun2(pagename, str) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/ArdCurStat/' + pagename + str,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
       responseType: 'blob',
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//验证验证码
function CheckPayRiskVerifCode(id, UserId, VerifCode) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/CheckPayRiskVerifCode?id=' + id + '&UserId=' + UserId + '&VerifCode=' + VerifCode,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//37收款账号联行号
function GetCnapsCodeByrevAccount(revAccount) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetCnapsCodeByrevAccount?revAccount=' + revAccount,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//修改费用类型
function UpdtataAdvanceTypeCost(form) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/UpdtataAdvanceTypeCost?Id=' + form.Id + '&Userid=' + form.Userid + '&TypeCost=' + form.TypeCost,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//判断发票编号是否重复
function GetCheckinvoiceNum(Id, invoiceNum) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetCheckinvoiceNum?Id=' + Id + '&invoiceNum=' + invoiceNum,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//40暂支打款公司名取可用账户
function GetCompanyNameAccount(CompanyName) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetCompanyNameAccount?CompanyName=' + CompanyName,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N59企微通知内容
function GetEnterpriseNotification(Id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetEnterpriseNotification?Id=' + Id,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N44计算暂支成本设置记录
function GetCalcuTransientCostSettings() {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetCalcuTransientCostSettings',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//手工计算
function CalcTransientCostsManually(month, way, BusiType) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/CalcTransientCostsManually?month=' + month + '&way=' + way + '&BusiType=' + BusiType,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//计算记录
function GetCalcTransientCostsList(data) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetCalcTransientCostsList?pageSize=' + data.pageSize + '&pageNum=' + data.pageNum + '&Type=' + data.type,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//42财务成本规则列表
function GetAdvFinanCostRules(data) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetAdvFinanCostRules?pageSize=' + data.pageSize + '&pageNum=' + data.pageNum + '&projectid=' + data.projectid,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//36关键字查联行号
function GetCnapsCodeByName(FullName, pageSize, pageNum) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetCnapsCodeByName?FullName=' + FullName + '&pageSize=' + pageSize + '&pageNum=' + pageNum,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N67重复堑支风险结果列表
function GetAdvancesRiskAlert(id) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/GetAdvancesRiskAlert?Id=' + id,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N68发送重复堑支风险验证码1
function SendPayRiskVerifCodeAdvances(id, userid) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/SendPayRiskVerifCodeAdvances?Id=' + id + '&UserId=' + userid,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N69重复堑支风险验证
function CheckPayRiskVerifCodeAdvances(id, userid, VerifCode) {
  return new Promise(resolve => {
    axios({
      method: 'get',
      url: APICbsTc + '/Advance/CheckPayRiskVerifCodeAdvances?Id=' + id + '&UserId=' + userid + '&VerifCode=' + VerifCode,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      }
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//N06核销列表
function WriteOffList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/WriteOffList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//提交核销
function SubmitWriteoff(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/SubmitWriteoff',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//无需核销
function NoWriteOffRequired(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/Advance/NoWriteOffRequired',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//预扣实缴差异
function GetDiffTaxPageList(jsonstr) {
  let data = JSON.stringify(jsonstr)
  return new Promise(resolve => {
    axios({
      method: 'post',
      url: APICbsTc + '/IncomeBatch/GetDiffTaxPageList',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Cookies.get("token1")
      },
      data
    })
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//A33取发薪项目本月批次号
function getProjectMonthBatch(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'getProjectMonthBatch',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取审批配置列表
function getApprovalConfigList(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "save",
        pagename: 'getApprovalConfigList',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取审批配置列表
function getApprovalConfig(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "save",
        pagename: 'getApprovalConfig',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//停用启用审批配置
function enableApprovalConfig(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'enableApprovalConfig',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除审批配置
function delApprovalConfig(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "save",
        pagename: 'delApprovalConfig',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//保存审批配置
function updataApprovalConfig(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: JSON.stringify(jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "save",
        pagename: 'updataApprovalConfig',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除工资单人员
function delSsnDetail(jsonstr, roletype) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename: 'delSsnDetail',
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// //1取项目数据
// function ReportAddApprov(data) {
//   return new Promise((resolve) => {
//     axios
//       .post(
//         APIEMP,
//         qs.stringify({
//           action: "save",
//           pagename: "ReportAddApprov",
//           userid: JSON.stringify(data),
//         })
//       )
//       .then((res) => {
//         try {
//           resolve(res.data);
//         } catch (e) {
//           resolve(false);
//         }
//       });
//   });
// }

//获取缴费名单
function getInsuredBillPayment(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename: 'getInsuredBillPayment',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取操作日志列表
function LogList(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'LogList',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取操作类型
function LogType(roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'LogType',
        userid: Cookies.get("userid-b"),
        jsonstr: '',
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//获取操作日志详情
function LosListDetail(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'LosListDetail',
        userid: Cookies.get("userid-b"),
        jsonstr: JSON.stringify(jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//作废 已退回的
function approverCancel(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "edit",
        pagename: 'approverCancel',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//报增待确认进入报增中 /作废
function ConfirmedEnterAdd(jsonstr, roletype,pagename) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "save",
        pagename,
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
//删除客服部工伤事故报告
function delWIAccidentReport(jsonstr, roletype) {
  return new Promise(resolve => {
    axios.post(
      APIJins,
      qs.stringify({
        action: "del",
        pagename: 'delWIAccidentReport',
        userid: Cookies.get("userid-b"),
        jsonstr: (jsonstr),
        roletype
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}
// 线索雷达监测列表-新
function getyxldjobLists(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICrm,
      qs.stringify({
        action: "edit",
        pagename: "getyxldjobLists",
        userid: Cookies.get("userid-b"),
        JsonStr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = JSON.parse(res.data)
            resolve(upmodeRes)
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      })
  })
}
// 线索雷达监测列表-查看岗位
function getjobByentidLists(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICrm,
      qs.stringify({
        action: "edit",
        pagename: "getjobByentidLists",
        userid: Cookies.get("userid-b"),
        JsonStr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = res.data
            resolve(upmodeRes)
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      })
  })
}
// 线索雷达监测列表-基础数据
function getJbBaseBasicdataList(jsonstr) {
  return new Promise(resolve => {
    axios.post(
      APICrm,
      qs.stringify({
        action: "edit",
        pagename: "getJbBaseBasicdataList",
        userid: Cookies.get("userid-b"),
        JsonStr: JSON.stringify(jsonstr)
      })
    )
      .then((res) => {
        try {
          if (res) {
            let upmodeRes = res.data
            resolve(upmodeRes)
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      })
  })
}
// 取用户详情新
function getauthJbUserDetailNew(userid, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getauthJbUserDetail",
          userid: userid,
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          // console.log('res',res)
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 判断是否有雷达监测的权限
function getpageroleList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getpageroleList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          // console.log('res',res)
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 取用户可用短信数量
function getsmsavailablenum(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getsmsavailablenum",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          roletype: roletype
        })
      )
      .then((res) => {
        try {
          // console.log('res',res)
          if (res) {
            let upmodeRes = JSON.parse(res.data)
            resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 取用户可用短信数量
function UpdateSignInfo(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "UpdateSignInfo",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          roletype: roletype
        })
      )
      .then((res) => {
        try {
          // console.log('res',res)
          if (res) {
            let upmodeRes = JSON.parse(res.data)
            resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//修改 项目 岗位
function EditEmpProJob(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "EditEmpProJob",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          // console.log('res',res)
          if (res) {
            let upmodeRes = JSON.parse(res.data)
            resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 取系统设置短信发送用户列表
function getBusiUersExtendList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getBusiUersExtendList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          // console.log('res',res)
          if (res) {
            // resolve(res.data);
            let upmodeRes = JSON.parse(res.data)
            resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 取系统设置短信发送用户详情
function getBusiUersExtenddetail(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getBusiUersExtenddetail",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          // console.log('res',res)
          if (res) {
            // resolve(res.data);
            let upmodeRes = JSON.parse(res.data)
            resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 修改短信设置
function upJbBusiUersExtend(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "upJbBusiUersExtend",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          // console.log('res',res)
          if (res) {
            // resolve(res.data);
            let upmodeRes = JSON.parse(res.data)
            resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 消息通知记录列表
function GetNotifyRecord(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getnotifyrecord",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          // console.log('res',res)
          if (res) {
            // resolve(res.data);
            let upmodeRes = JSON.parse(res.data)
            resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
//营销雷达2.0
// 任务列表
function gettaskList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "gettaskList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 采集平台列表
function getstrplatformList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getstrplatformList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 平台来源列表 筛选
function getstrplatformsearch(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getstrplatformsearch",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 任务的新增修改
function savetaskinfo(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "save",
          pagename: "savetaskinfo",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 关闭开启 删除任务
function uptaskinfo(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "save",
          pagename: "uptaskinfo",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 区域设置列表
function getroleareaList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getroleareaList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 添加修改区域配置
function saverolearea(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "save",
          pagename: "saverolearea",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取任务城市列表
function gettaskcityList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "gettaskcityList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 查询企业联系方式
function getEntContactlist(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getEntContactlist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 添加跟进
function addEntfollowNum(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "save",
          pagename: "addEntfollowNum",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 点击查看联系人保存记录
function addlookEntContact(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "save",
          pagename: "addlookEntContact",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 营销雷达-统计接口
function getReportprodata(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getReportprodata",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 营销雷达-企业库
function getEntListsNew(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "getEntLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
            // let upmodeRes = JSON.parse(res.data)
            // resolve(upmodeRes);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 营销雷达-导出
function outputReportListNew(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "edit",
          pagename: "outputReportList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 消费记录明细及导出
function getexpenselist(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getexpenselist",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 用户取自己的 BusiIdB,BusiType
function getbusiIdbyuserId() {
  return new Promise((resolve) => {
    axios
      .post(
        APICert,
        qs.stringify({
          action: "edit",
          pagename: "getbusiIdbyuserId",
          userid: Cookies.get("userid-b"),
          jsonstr: Cookies.get("userid-b")
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 花名册改版
// 根据id获黑名单详情
function getblackdetail(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getblackdetail",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 取黑名单列表
function getblackLists(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getblackLists",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 新增修改黑名单
function bsaveJbblack(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "bsaveJbblack",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 删除黑名单
function bdelJbblack(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "del",
          pagename: "bdelJbblack",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 花名册列表（换brole参数都不变）
function bgetempcustlist(jsonstr,roletype,pagename) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename,
          userid: Cookies.get("userid-b"),
          roletype,
          strJson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 员工详情
function PersonInfo(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: 'PersonInfo',
          userid: Cookies.get("userid-b"),
          roletype,
          strJson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 员工详情流程
function PersonInfoFlow(jsonstr,roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename:'PersonInfoFlow',
          userid: Cookies.get("userid-b"),
          roletype,
          strJson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 修改合同信息
function UpdateContract(jsonstr,roletype,pagename) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename,
          userid: Cookies.get("userid-b"),
          roletype,
          strJson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 员工信息修改
function UpdatePerson(jsonstr,roletype,pagename) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename,
          userid: Cookies.get("userid-b"),
          roletype,
          strJson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 创建h5二维码
function GetProjectQRCode(jsonstr,roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename:'GetProjectQRCode',
          userid: Cookies.get("userid-b"),
          roletype,
          strJson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 获取工作台数据
function getworkrecount(roletype, jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getworkrecount",
          userid: Cookies.get("userid-b"),
          roletype,
          jsonstr: JSON.stringify({ strtype: jsonstr })
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 花名册详情（换brole参数都不变）
function bgetcurrdata(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "bgetcurrdata",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data);
            if (result && result.msg) {
              resolve(result.msg);
            } else {
              resolve(false);
            }
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 花名册详情保存修改（换brole参数都不变）
function bmodifycurrdata(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "bmodifycurrdata",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data)
            result.status == "ok" ? resolve(true) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 首页雇员数据
function ServiceHomeData(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "ServiceHomeData",
          roletype,
          userid: Cookies.get("userid-b"),
          strjson: (jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data)
            resolve(result)
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 待面试列表
function Interview(jsonstr, roletype, pagename) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename,
          roletype,
          userid: Cookies.get("userid-b"),
          strjson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data)
            resolve(result)
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 待面试操作
function InterviewOption(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "InterviewOption",
          roletype,
          userid: Cookies.get("userid-b"),
          strjson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data)
            resolve(result)
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 标签列表
function TagList(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "TagList",
          roletype,
          userid: Cookies.get("userid-b"),
          strjson: (jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data)
            resolve(result)
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 待入职操作
function WaitEntryOption(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "WaitEntryOption",
          roletype,
          userid: Cookies.get("userid-b"),
          strjson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data)
            resolve(result)
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 待面试导出
function InterviewExcel(jsonstr, roletype, pagename) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename,
          roletype,
          userid: Cookies.get("userid-b"),
          strjson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data)
            result.status == "ok" ? resolve(result) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 待入职导入
function WaitEntryImport(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: 'WaitEntryImport',
          roletype,
          userid: Cookies.get("userid-b"),
          strjson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data)
            resolve(result)
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 待入职删除
function WaitEntryDelete(jsonstr, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: 'WaitEntryDelete',
          roletype,
          userid: Cookies.get("userid-b"),
          strjson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data)
            resolve(result)
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 查询历史导出的（换brole参数都不变）
function bgetimphistorycfg(tableid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "bgetimphistorycfg",
          userid: Cookies.get("userid-b"),
          tableid: tableid
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 取最新一次导入的数据结果（换brole参数都不变）
function bgetlastimpdata(custname) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "bgetlastimpdata",
          userid: Cookies.get("userid-b"),
          custname: custname
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 删除雇员（换brole参数都不变）
function bdelempuser(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "del",
          pagename: "bdelempuser",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data)
            result.status == "ok" ? resolve(true) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 商保待入职列表
function getsignResumeListsInsu(pagename, jsonstr,roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: pagename,
          roletype,
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data)
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 商保在职未在保、电子签列表
function GetsignResumeListsonworkInsu(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "GetsignResumeListsonworkInsu",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data)
            resolve(result);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 导出商保在职未在保、电子签列表
function expGetsignResumeListsonworkInsu(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "GetsignResumeListsonworkInsu",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            // let result = JSON.parse(res)
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

function InEmpSignExcel(strjson, roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "ExportsignResumeListsonworkInsu",
          userid: Cookies.get("userid-b"),
          roletype: roletype,
          strjson: JSON.stringify(strjson)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}

// 花名册详情导出
function bdowncurrdata(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "bdowncurrdata",
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data);
            result.status == "ok" ? resolve(result.msg) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 花名册（详情）详情导出
function OutExcel(jsonstr,roletype) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "OutExcel",
          userid: Cookies.get("userid-b"),
          roletype,
          strJson: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            let result = JSON.parse(res.data);
            result.status == "ok" ? resolve(result.msg) : resolve(false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 身份证校验（换brole参数都不变）
function getcheckidcard(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getcheckidcard",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 查看身份证照片
function getidcardurl(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getidcardurl",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 身份证照片保存
function bsaveIdcardpic(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "bsaveIdcardpic",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 分配部门标签
function bsaveOrganLabel(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "bsaveOrganLabel",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 查看部门标签
function getOrganLabel(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getOrganLabel",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          if (res) {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 更新待入职商保里信息身份证、姓名
function updateStatusinfo(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "updateStatusinfo",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 流程中未入职列表
function getStatusonworkInf(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getStatusonworkInf",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 处理流程中未入职数据
function saveStatusonworkInf(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "save",
          pagename: "saveStatusonworkInf",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取客服报表
function getReportProjectKF(jsonstr,pagename) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename,
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取导出记录
function getReportOutList(strJson) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename:'getReportOutList',
          userid: Cookies.get("userid-b"),
          strJson: JSON.stringify(strJson),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取报表服务中心
function getReportProDep2(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIB,
        qs.stringify({
          action: "edit",
          pagename: "getReportProDep2",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
        })
      )
      .then((res) => {
        try {
          if (res.status == "200") {
            resolve(JSON.parse(res.data));
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 新增修改项目（新版）
function bsaveJbProjectversion1(jsonstr, jsonstrsub, jsonstrpic) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "save",
          pagename: "bsaveJbProjectversion1",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr),
          jsonstrsub: JSON.stringify(jsonstrsub),
          jsonstrpic: JSON.stringify(jsonstrpic)
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取项目列表（新版）
function getProjectListsversion1(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getProjectListsversion1",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取项目详情（新版）
function getProjectDetailversion1(projectid) {
  return new Promise((resolve) => {
    axios
      .post(
        APIEMP,
        qs.stringify({
          action: "edit",
          pagename: "getProjectDetailversion1",
          userid: Cookies.get("userid-b"),
          projectid: projectid
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}
// 获取项目主体列表（新版）
function GetAllLegalSubjectList(jsonstr) {
  return new Promise((resolve) => {
    axios
      .post(
        APICrm,
        qs.stringify({
          action: "save",
          pagename: "GetAllLegalSubjectList",
          userid: Cookies.get("userid-b"),
          jsonstr: JSON.stringify(jsonstr)
        })
      )
      .then((res) => {
        try {
          resolve(res.data);
        } catch (e) {
          resolve(false);
        }
      });
  });
}

//更新银行余额
function startBalanceUpdate(jsonstr, roletype,pagename) {
  let data = {
    userid: Cookies.get("userid-b"),
    roletype: roletype,
    parmjsonstr: (jsonstr)
  }
  return new Promise(resolve => {
    axios.post(
      APICbs,
      qs.stringify({
        action: "edit",
        pagename,
        jsonstr: JSON.stringify(data)
      })
    )
      .then((res) => {
        try {
          resolve(JSON.parse(res.data));
        } catch (e) {
          resolve(false)
        }
      })
  })
}

export default {
  GetAllLegalSubjectList,
  getProjectListsversion1,
  BasicFun,
  GetCompanyNameAccount,
  EditEmpProJob,
  IvoiceFun,
  WaiterWorkerOption,
  remitAdvance3,
  GetFinalStatementEdit,
  GetTicketTypeEdit,
  GetBillingItemEdit,
  GetProjectInvoiceContentList,
  GetBillingItem,
  PersonInfo,
  GetInvoiceApplyForView,
  GetTicketType,
  GetInvoiceEdit,
  GetCheckinvoiceNum,
  GetAdvPaymenCard,
  GetJbBusiaAdvLogWritFinans,
  GetProjectEmailList,
  UpdtataAdvanceTypeCost,
  GetCorporationData,
  GetAllLowUser,
  PostThirdParty_queryAuthQrCode,
  GetRedPunchAlreadyInvoiceView,
  GetAlreadyInvoiceView,
  GetBillingItemDetails,
  UpdatePerson,
  getApplicationPayrollListCount95,
  getApplicationPayrollList95,
  getElectroniAdvPayment,
  downloadEleReceiptPayNum,
  bsaveJbProjectversion1,
  SubmitList,
  getReportProDep2,
  getReportProjectKF,
  saveStatusonworkInf,
  getStatusonworkInf,
  updateStatusinfo,
  DownLoadInv,
  GetsignResumeListsonworkInsu,
  expGetsignResumeListsonworkInsu,
  InEmpSignExcel,
  getsignResumeListsInsu,
  bdowncurrdata,
  getOrganLabel,
  getElectronicReceiptPayment,
  bsaveOrganLabel,
  bsaveIdcardpic,
  UpdateContract,
  getidcardurl,
  getcheckidcard,
  bdelempuser,
  expErrInfo,
  GetCnapsCodeByName,
  GetCnapsCodeByrevAccount,
  GetRiskAlertResultById,
  CheckPayRiskVerifCode,
  SendPayRiskVerifCode,
  CheckPerson,
  PersonInfoFlow,
  bgetlastimpdata,
  GetApplyInComeCheckList,
  bgetimphistorycfg,
  bmodifycurrdata,
  bgetcurrdata,
  bgetempcustlist,
  bdelJbblack,
  getRefundList,
  bsaveJbblack,
  getblackLists,
  getblackdetail,
  registerRefund,
  getbusiIdbyuserId,
  getexpenselist,
  distinguishImg,
  outputReportListNew,
  getEntListsNew,
  getReportprodata,
  addlookEntContact,
  addEntfollowNum,
  getEntContactlist,
  gettaskcityList,
  saverolearea,
  getroleareaList,
  uptaskinfo,
  savetaskinfo,
  getstrplatformsearch,
  getstrplatformList,
  gettaskList,
  getExList,
  AdvanceFun,
  ExOption,
  GetBankStatFieldMatching,
  GetAdvancePageList,
  RecoverSys,
  exportTaxList,
  ExpOfflinePayrollList,
  GetDiffTaxPageList,
  SubmitWriteoff,
  GetApprovalList,
  VerifiDepartAudit,
  ExportSpecialDeductionPageList,
  NoWriteOffRequired,
  RecoverXft,
  cbsPayAdvance,
  remitAdvance,
  ImportOfflinePayment,
  GetAdvancesDetail,
  getPayrollCompanyList,
  CheckTaxState,
  GetWriteoffDetail,
  WriteOffList,
  AdvanceExpFun,
  GetFinancialProject,
  IsFinancial,
  addUpdataAdvanceVerif,
  GetNotifyRecord,
  upJbBusiUersExtend,
  getBusiUersExtenddetail,
  getBusiUersExtendList,
  getsmsavailablenum,
  getpageroleList,
  getauthJbUserDetailNew,
  getyxldjobLists,
  RelmpEmp,
  getjobByentidLists,
  getJbBaseBasicdataList,
  bgetLoginauthPowerInfChange,
  GetAdvancesRiskAlert,
  Resetpwdmodifysta,
  updateauthJbUserInfo,
  getauthJbUserDetail,
  SendPayRiskVerifCodeAdvances,
  getauthUserInfoByorgancode,
  CheckPayRiskVerifCodeAdvances,
  ServiceHomeData,
  Interview,
  InterviewOption,
  bdelauthStationList,
  bupdateauthStationList,
  bgetStationauthList,
  deleteRoleList,
  InterviewExcel,
  bupdateauthRoleList,
  bgetRoleauthList,
  SocialFun,
  SocialExpFun,
  certFun,
  PassApplyInfo,
  UpdateApplyInfo,
  getImportquerytemplate,
  getbtnPowerIdBypage,
  bgetLoginauthPowerInf,
  baLLGetauthPowerInf,
  sendDataToCrm,
  delSocialSecurity,
  GetTicketTypeForInvoice,
  getresourcejobcustomerlist,
  getproListsonwork,
  WaitEntryOption,
  WaitEntryImport,
  WaitEntryDelete,
  TagList,
  AIbasicFun,
  GetBillingItemDetailsForInvoice,
  handleConstrTeamRecertif,
  applyConstrTeamRecertif,
  getConstrTeamPersonremind,
  getConstrTeamremind,
  getConstrTeamRecertif,
  createcustomer,
  updatacustomer,
  batchstartcert,
  updatauserpwd,
  getworkingdisplaystation,
  getcustomeruser,
  updatacustomeruser,
  getcustomer,
  getbairongExecutionPro,
  walletrechargeadjustment,
  getMenuProduct,
  addEntClaim,
  getpsnExprotModeSign,
  getImportModeUrl,
  psnAnlysisExcelInfstatus,
  saveProjectImpSet,
  getProjectImpSet,
  uploadVoice,
  getDataList,
  getAccountingRecordsList,
  addClaimRecord,
  getClaimRecordList,
  revocationClaimRecord,
  addNewMoneyReceived,
  importToCbsRtnAmt,
  updataCollectingBank,
  getProAccountSetDetail,
  delCollectingBank,
  updataCollectingBankstateStr,
  updataInvoiceTitle,
  delInvoiceTitle,
  updataPayMaster,
  delPayMaster,
  updataProAccountSet,
  getCompfinanceSet,
  addCompfinanceSet,
  addDistributionChannel,
  getDistributionChannelList,
  getApplicationPayrollList,
  getApplicationPayrollListCount,
  addApplicationPayroll,
  getApplicationPayrollDetail,
  getOriginalImportDetail,
  updataApplicationPayroll,
  cancellApplication,
  checkCurrentProjectSubmiTdetails,
  registerRemitSuccess,
  FailurePayAgainHandMade,
  registerRemitFail,
  taxBureauPersonalTaxAcquisition,
  recalculate,
  CreateOrEditInComeDetail,
  getTempSuspList,
  SetPersonnelCheck,
  SetCalculateTax,
  withSubmitPay,
  GetErrorMsgPageList,
  modifyTempSuspInfo,
  SetAllPersonnelOrZeroCheck,
  SetAllPersonalOrZeroCalculateTax,
  getAllLegalAccount,
  financeFailureProcessing,
  failurePayToArchive,
  failurePayAgain,
  BuildInComeDetailBatch,
  CheckBuildInComeDetailBatch,
  CheckCacuTaxInComeDetailBatch,
  PullInComeTaxCacuStatus,
  PullInComeStatus,
  updateEmpPhone,
  outputProjectList,
  SetInComeDetailBatchStatus,
  ExportIncomeBatchPageList,
  ExportAdvanceList,
  ExportBatchProjectList,
  ExportBatchPersonList,
  ExportBatchCompanyList,
  ExportWaitingBatchProjectPageList,
  ExportBatchDetailPersonPageList,
  getOAHomeInit,
  ZeroRepair,
  ZeroRepairTax,
  ZeroRepairList,
  payrollApplicationExport,
  CancellApplication,
  DismissInComeBatchStatus,
  GetDeclarationProjectPageList,
  SetInComeBatchStatus,
  ApplyIncomeDeclaration,
  getSucceedToPaylList,
  GetProjectQRCode,
  H5ProjectInfo,
  OutExcel,
  H5ProjectOption,
  getFailedDetaiOrToPaylList,
  modifyPaymentFailure,
  getpaylistacc,
  getpdfcont,
  addOfflineInTaxDecl,
  getOfflineInTaxDeclList,
  getPayReferenceNumStrs,
  getInternalCompNameList,
  GetIncomePageList,
  ApplySalaryFun,
  ApplySalaryExpFun,
  SetInComeTimeSetting,
  GetSpecialDeductionPageList,
  SetInComeDeclarationSetting,
  ExportInComeDeclarePageList,
  GetInComeTimeSetting,
  PullInComeStatusNotDeclare,
  CheckCacuTaxInComeDetailNotDeclare,
  PullInComeTaxCacuStatusNotDeclare,
  StartPersonalCheck,
  SetAllCompanyDeclare,
  GetIncomePersonPageList,
  GetInComeDeclarePageList,
  DeleteInComeDetail,
  exportTaxCalcuResultDetail,
  getImportOfflinePayrollList,
  getOATodolist,
  ExportInComeDetail,
  ImportInComeDetail,
  ExportInComePersonalDetail,
  getpayaccstr,
  BasicGetFun,
  IvoiceGetFun,
  ReSubmitFail,
  getworkrecount,
  WFSearch,
  delSsnDetail,
  aOapiNodeSendWork,
  AOapiNodeReturnWork,
  getGenerWorkerList,
  getExcelHeadByUrl,
  getImportTempDetail,
  addUpdataImportTempList,
  getImportTempList,
  delImportTemp,
  StopCheck,
  StopTax,
  getBaiduToken,
  baiduOCR,
  importOfflinePayrollData,
  cashierFinancialAudit,
  selectPayrollBankAccount,
  cbsRemit,
  sendusertoxft,
  sendusertax,
  senduserlisttax,
  senduseralltoxft,
  getreqseq,
  withdrawClaim,
  modifyAssociatedPayment,
  getProjectMonthBatch,

  getTeamUserDetail,
  delJbTeamUser,
  saveJbTeamUserInfo,
  checkJbTeamUser,
  getCostRecordsdetailLists,
  delConstrCost,
  delchat,
  getrestnumconversations,
  getchattitel,
  AddEmponwork,
  fallbackPsnStatus,
  checkDrzByidcard,
  getchatlist,
  sendchatmsg,
  getTeamUserList,
  sendBillMonthinf,
  chkPsnTableFormql,
  saveTeamUserid,
  getBillMonthinfdetailList,
  getBillMonthLists,
  outputReportList,
  getIsUsedPersonCode,
  getIsUsedteamCode,
  getbaseBaList,
  ByOutPerson,
  SelFun,
  OutputByRpo,
  getJbbaseEmpColumnPro,
  sendReportRecordsinf,
  saveReportRecordsinf,
  getConstrTeamPayeelist,
  saveConstrComfirm,
  getCostRecordsdetail,
  saveConstrCost,
  rcFun,
  rcGetFun,
  rcExpFun,
  getCostRecordsLists,
  getConstrCostLists,
  getIsUsedcloumname,
  getConstrCostHeard,
  getAreaTree,
  OutputTeamList,
  saveReportReceivableinf,
  saveConstrExamStatus,
  saveConstrDtexitDate,
  getUtilityBillLists,
  getReportReceivables,
  saveConstrTeamPerinfo,
  getConstrTeamPerDetail,
  getConstrTeamPersonLists,
  getConstrTeamDetail,
  saveConstrTeaminfo,
  getConstrTeamLists,
  getAreaLists,
  delUtilityBill,
  getcrmImpDataList,
  anlycrmsisExcelInf,
  chkcrmTableForm,
  getcrmExprotMode,
  getcrmOutPutMode,
  getEcustColumnList,
  outputEcrmList,
  getCusLeadsLists,
  getEcrmColumnList,
  getPythonBasicData,
  getClueData,
  taskPsnStatuszz,
  getjobappointtime,
  getjobdateappoint,
  getRecruitPlandeps,
  updateDtreachtime,
  getUserInfoBytopuser,
  getBasicDatas,
  outputJobList,
  getAreaAll,
  getErrtPsnImpDataList,
  broleInducRegister,
  checkidcardEmp,
  getsignResumeListsonwork,
  getresourcejobcategoryblist,
  quitEmpData,
  brolequitEmpData,
  getapplyjoobqrcodegenerated,
  broleInducEmpData,
  savetransferrecords,
  transferEmpData,
  getresourceavailabletime,
  getresourcechangejoblist,
  saveSigninfo,
  getempdetail,
  inducEmpData,
  ArdCurStatGetFun2,
  getresumestatuscheck,
  getsignResumecount,
  saveProcessRecords,
  getsignResumeRecordLists,
  getProcessColumnList,
  delresumepro,
  getresumePsndistcount,
  getfollowuserc,
  getqwUserid,
  getprojectpersondetails,
  getOrganstrsreach,
  wxappgetjoblist,
  GetProjectInfo,
  getnotifyrecord,
  gettemplatelist,
  sendnotify,
  getdistResumerecords,
  getdistrecords,
  getSetUpgdUserid,
  savePsnStatusrecords,
  savePsnfowrecords,
  ArdCurStatGetFun,
  ConfirmedEnterAdd,
  DownloadEleReceiptByAttrMonth,
  getresumePsnstatusrecords,
  getresumePsnfowrecords,
  outputResumeList,
  saveSetUpgdUserid,
  checkResumeMobile,
  getResumeDetail,
  gethotjobopeningslist,
  distResumeinfo,
  LaunchResumepublic,
  saveResumeinfo,
  getPsnOutPutMode,
  getpsnExprotMode,
  savelabelResume,
  saveResumeWorkState,
  GetresumelabelLists,
  getsignResumeLists,
  getpublicResumeLists,
  getCommonlabelLists,
  getprivateResumeLists,
  getJbbasePageColumnList,
  getdictdatalistbyid,
  GetDictDataTreeListById,
  getPsnImpDataList,
  getPsnDAtaOutList,
  getPsnDataOutStatus,
  psnAnlysisExcelInf,
  chkPsnTableForm,
  getjobdetails,
  deljobdetails,
  appropriatFundsList,
  getUnsuccessfulTaxList,
  draftBecomesSalary,
  GetApprovalSuccess,
  saveJbBusiRecruitPlanterm,
  saveJbBusiRecruitPlan,
  getRecruitPlanTerm,
  getRecruitPlanDetail,
  initLintSrcUserCode,
  checkProStrservuserid,
  getRemindProjectLists,
  getSystemConfig,
  PostOcrbd,
  DeleteIsZeroInComeDetail,
  updateProService,
  UpdateSignInfo,
  GetAdvOrderCode,
  getOutFnncDataSourceErr,
  getFinanceDataImpError,
  GetUserInfoBytopuser,
  getUserInfoBytoporgancode,
  getOutCustLists,
  getJbUserRolepageDetail,
  delbCust,
  imgCompress,
  fileToImg,
  getOutProjectLists,
  getupdateEmpResumeUser,
  getOutResumeUser,
  getEmpResumeLists,
  getOutEmpBaseUser,
  getEmpBaseUsersLists,
  getJbPageColumnDefList,
  updateProStatue,
  getorganstr,
  getUserInfoByorgancode,
  getSearchCustindust,
  getParameterList,
  BSaveJbProject,
  getProjectLists,
  getProjectDetail,
  getProjectDetailversion1,
  getCustLists,
  getCustDetail,
  saveJbCust,
  financeSourcereport,
  getFinanceSourceStatistics,
  updateEmpCustListWx,
  financeSourceData,
  getScreenData,
  ArdCurStat,
  uploadMaxFile,
  GetContractPreview,
  ReportExpFun,
  getFinanceSourceData,
  getAllAnalysisTotalData,
  getOutAnalysisTotalData,
  getTaskAnalysisTotalData,
  getAnalysisTable,
  getAnalysisTotalData,
  getAnalysisColumnInf,
  getfinancetotalDatacus,
  errorfinanceDataTable,
  getaccountDate,
  BuildOrder,
  BuildCheckList,
  closeaccount,
  BuildTime,
  reportfinanceCurrDataTable,
  getfinancetotalData,
  modifyfinancecurrimpdata,
  updatefinancemodifydata,
  getfinanceimperrdata,
  getfinanceexprotmode,
  getfinanceimpdatalist,
  outputQueryEmpCust,
  getBackUpUsers,
  empUndoinputData,
  getsrarchinstAllList,
  chkimpdatatbtype,
  errorCurrDataTable,
  gettencentwxrecruitmentplanjob,
  getlastimpdata,
  reportCurrDataTable,
  getBaseUserInCityList,
  getUserBaseCitydetail,
  getUserCity,
  getUserBasecensusdetail,
  getUserBasecensus,
  customerInfo,
  getuseridbymobile,
  saveAccountInformation,
  userLogin,
  iterateCustomer,
  uploadImage,
  getCompanyImages,
  deletePic,
  uploadAvatar,
  roleDivision,
  roleOffspring,
  codeToInfor,
  getServeCity,
  provinces,
  citys,
  areas,
  checkInv,
  uploadCert,
  getTableData,
  GetEnterpriseNotification,
  GetCalcuTransientCostSettings,
  CalcTransientCostsManually,
  GetAdvFinanCostRules,
  directPaymentSubmit,
  GetCalcTransientCostsList,
  addImportFiled,
  returnExcelSrc,
  getImportFiledInfo,
  getImportProcess,
  getImportInfo,
  getPathInfo,
  editEmployeeInfo,
  syncFromOA,
  backupdata,
  getErrorInfo,
  bGetPowerList,
  getLoginPowerInf,
  getRoleInfo,
  checkJbUserInfo,
  bSaveRoletypeInfo,
  getInststr,
  deleteEmployee,
  blacklistEmp,
  getremindlist,
  restedelemp,
  getremindcount,
  exportEmp,
  ReportReduce,
  jobeditorsavecheck,
  getBaseInstList,
  getUserInfoByInstrole,
  getAllRoleEmpList,
  getUserDetail,
  updateInstInfoById,
  saveLowUserInfo,
  delroleinfUser,
  getUserTopInst,
  GetcustomerInfoByuserid,
  bCheckUserInfo,
  getExpRec,
  getfinanceempcustlist,
  getfinanceemptabledef,
  delfnncuserimport,
  isfinanceImpDataInsu,
  delempuserimport,
  H5OutExcel,
  getfinancecurrdata,
  getfinanceinputmode,
  getfinanceempcolumninf,
  chkfinanceimpdatatbtype,
  financeAnlysisExcelInf,
  getLastExpData,
  getBlackList,
  Getlaunch_code,
  synchronizationInst,
  editEmployeeInfo2,
  getImportMode,
  getHistoryFiled,
  getErrColumn,
  getBackList,
  getsrarchinstlist,
  getsrarchinstobjinstlist,
  getsrarchinstobjlist,
  updateEmpCustListstrBusiStat,
  getallEmplowertListInfo,
  updateEmpCustListgdUserId,
  updatecustBystrfileNo,
  getHistoryInfo,
  putStorage,
  getElectroniAdvDirectCaym,
  nonertndataquery,
  getJbUserDetail,
  getsignatureinfo,
  getqwcodeurl,
  getorganstr1,
  saveJbOrganization,
  getOrganizationById,
  getUserInfoByorgancode1,
  delOrganInfoById,
  saveJbUserInfo,
  getTreestr,
  getrecrrservicesdepart,
  saveJbParameter,
  delJbParameter,
  getParameterList1,
  gettestreport,
  ReportFun,
  FinancialDataSourcesSystem,
  gettestreportHead,
  setLabelManagement,
  GetFinancialDataSourcesSettings,
  setlabelmanagementbatch,
  searchRecruitmentneed,
  GetSpecialSubjectList,
  GetInvoiceEditDetails,
  saveJbBusiRecruitPlandepuser,
  getplancomrecordprojectlist,
  getprojectstrservuseridList,
  getArea,
  getTaskList,
  addTask,
  getCollectionConfig,
  addCollectionConfig,
  getEntLists,
  getrpcyclelist,
  editrpcycle,
  addcomrecord,
  jobeditorsave,
  getcomrecord,
  CreateBuildOrder,
  GetRefreshs,
  getprojectlist,
  ArdCurStatExp,
  getcertproductbusi,
  updatacertproductbusi,
  getcertorderdetail,
  updatacertmenu,
  AdvanceGetFun,
  getcertorderlist,
  getcertmenu,
  CreateQrCode,
  GetQrCode,
  QueryRecord,
  DeleteQrCode,
  StopQrCode,
  QueryCert,
  ReCreateQrCode,
  QueryCertReport,
  getlegalsubjectlist,
  getlegalsubjectdetails,
  updatelegalfinance,
  getlegalfinancedetails,
  updatelegalsubject,
  getsslist,
  getbIlist,
  updatess,
  getcustomecaselist,
  updatecustomecase,
  getcontracttemplist,
  updatecontracttemp,
  getBiddingwebsiteList,
  updateBiddingwebsite,
  getcompIntroducelist,
  updatecompIntroduce,
  updatefilemanage,
  modifyMobilePhone,
  getApprovalByUserId,
  getfilelist,
  templateFileUpload,
  getInsuredPersonsList,
  updatebi,
  startcert,
  getauthUserBasicReport,
  upuserBasicReport,
  getentcontactnum,
  getentContactnumbyother,
  addEntcontactnum,
  updatarecruitplanstatus,
  GetLabelManagement,
  gettestreportrefesh,
  importModel,
  updataEntfolloEntAdd,
  submitApproval,
  getReminderTag,
  doReminderTag,
  getApprovalProgress,
  getTrialSubmitList,
  delWIAccidentReport,
  getWIAccidentReport,
  updataWIAccidentReport,
  getWIAccidentReportList,
  getAsyncApplyInsuredProgress,
  getMonthlyEconSummary,
  getAsyncBatchSendProgress,
  getMasterList,
  updataWiservice,
  approverCancel,
  doMasterList,
  getProjectAllLists,
  getWiserviceReport,
  delWiservice,
  exportInjuryReport,
  getWiserviceList,
  getWiinsuranceGroup3List,
  getWiinsuranceGroup3,
  updataWiinsuranceGroup3,
  delWiinsuranceGroup3,
  getWiinsuranceGroupReconc4List,
  getWiinsuranceGroupReconc4,
  updataWiinsuranceGroupReconc4,
  delWiinsuranceGroupReconc4,
  getWiinsuranceGroupDa5List,
  getWiinsuranceGroupDa5,
  updataWiinsuranceGroupDa5,
  delWiinsuranceGroupDa5,
  getWiclaimDetails1Ss6List,
  getWiclaimDetails1Ss6,
  ExportSettTaxResult,
  updataWiclaimDetails1Ss6,
  delWiclaimDetails1Ss6,
  getWiclaimDetails2Bi7List,
  getWiclaimDetails2Bi7,
  updataWiclaimDetails2Bi7,
  delWiclaimDetails2Bi7,
  updataWiclaimDetails3Bi8,
  getWiclaimDetails3Bi8List,
  getWiclaimDetails3Bi8,
  delWiclaimDetails3Bi8,
  getWorkAccidentProjectById,
  getInsuredBillPayment,
  LogList,
  LogType,
  getApprovalConfigList,
  updataApprovalConfig,
  getApprovalConfig,
  BatchFillSystemDataAdvanceWages,
  enableApprovalConfig,
  delApprovalConfig,
  LosListDetail,
  updataPhoneIninsurance,
  getOACostDetail,
  disableOrganInfoById,
  getroleareaIsdataAdmin,
  updataApprovalDetail,
  delApprovalDetail,
  getOutUserLists,
  disableJbParameter,
  checkJborganname,
  editPsw,
  TaskSetupFun,
  TaskSetupGetFun,
  getContractList,
  getBestSingnSOSUrl,
  getTempCombined,
  delComtractTemp,
  GetTempListEmployee1,
  updataContractTemp,
  getLegalSubjectList,
  generateEConQRCode,
  getContractApproList,
  templatesByProjectList,
  submitESigningInfo,
  addOfflineSigning,
  getBestSingndownloadfile,
  sendtextMessagesContracts,
  batchImportQuery,
  getReportColumnList,
  delContractAppro,
  contracttApproval,
  outReportExcel,
  getReportOutList,
  saveRecruitdepuserbatch,
  getContractListByPhone,
  contractsRemind,
  SubmitEcon,
  econQRCodeRegisList,
  qrCodeDeactivation,
  placefileContracts,
  getImportTemplate,
  getImportSigningTableTemplate,
  offlineSigningImportTemplate,
  getLegalSubjec,
  editInsurancManage,
  editInsurancManageEnabled,
  delInsurancManage,
  getInsurancManage,
  getServiceProviderList,
  editServiceProvider,
  editAuditorSetup,
  reportAddApprov,
  applyInsured,
  approvalEnd,
  approvalReturn,
  getInsureClaimList,
  customerServiceApproved,
  getInsureImportTemplate,
  getOrderPolicyManageList,
  getApprovalDetails,
  insuranceH5,
  getApprovalByProjectPower,
  getInsurancManageByUserid,
  delServiceProvider,
  delAuditorSetup,
  getbslist,
  GetBdToken,
  RPAFun,
  exportRPA,
  DownloadEleReceiptPayNum,
  RPAdel,
  SRFun,
  SRGetFun,
  IvoiceEXPFun,
  SREXPFun,
  GetTaskDefaultConfiguration,
  updatebillingscheme,
  getAuditorSetupList,
  updatePersonNoNeedInsure,
  getInsurancManageList,
  getApplicationPayrollDetailN1,
  getExpProcess,
  claimSpecifiedMonth,
  sendUserALLToXFTDeclartion,
  startBalanceUpdate,
  sendUserListTaxDeclartion
};
</script>
